<template>
  <v-card>
    <v-toolbar
      class="settings-window-toolbar"
      flat
      height="80"
    >
      <v-avatar
        :color="$t('Settings.Documents.Toolbar.Color')"
      >
        <v-icon dark>
          {{ $t('Settings.Documents.Toolbar.Icon') }}
        </v-icon>
      </v-avatar>

      <v-toolbar-title class="pl-3">
        <div class="body-3">
          {{ $t('Settings.Documents.Toolbar.Title') }}
        </div>
        <div class="text-caption">
          {{ $t('Settings.Documents.Toolbar.Subtitle') }}
        </div>
      </v-toolbar-title>

      <v-spacer />
    </v-toolbar>

    <v-divider />

    <v-card-text
      id="settingsWindow"
      style="overflow-y: auto;"
    >
      <template v-if="viewData">
        <v-expansion-panels
          v-model="expansionPanel"
          flat
          focusable
        >
          <!-- Order Document -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div class="d-flex justify-start align-center">
                <v-icon class="pr-3">
                  {{ $t('Settings.Documents.OrderDocument.Icon') }}
                </v-icon>
                <h5 class="text-body-2 font-weight-bold">
                  <lang-search-highlight
                    :lang-text="$t('Settings.Documents.OrderDocument.Title')"
                    :search-text="langSearchText"
                    highlight
                  />
                </h5>
              </div>
            </v-expansion-panel-header>

            <v-divider />

            <v-expansion-panel-content>
              <v-container
                class="pa-0 py-2"
                fluid
              >
                <v-row
                  align="center"
                  dense
                >
                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.ShowSimple.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.ShowSimple.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.ShowSimple"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.ShowSimple ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0 text-no-wrap"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.PrintPerMachine"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.PrintPerMachine ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0 text-no-wrap"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.PrintTableOrder.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.PrintTableOrder.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                    <div class="text-caption orange--text text--darken-2">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.PrintTableOrder.Hint')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.PrintTableOrder"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.PrintTableOrder ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0 text-no-wrap"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowCategories.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowCategories.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.ShowCategories"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.ShowCategories ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>


                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowLogo.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowLogo.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.ShowLogo"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.ShowLogo ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col
                    class="pa-0 ma-0"
                    cols="12"
                  />

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.LogoWidth.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.LogoWidth.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-text-field
                      v-model="viewData.OrderDocument.LogoWidth"
                      :disabled="!userCanManage"
                      class="elevation-0 d-inline-block ml-2"
                      dense
                      hide-details
                      min="0"
                      outlined
                      required
                      single-line
                      step="1"
                      style="min-width: 100px; max-width: 100px;"
                      suffix="mm"
                      type="number"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowMap.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowMap.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                    <div class="text-caption grey--text">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowMap.Hint')"
                        :search-text="langSearchText"
                        highlight
                      />
                      <router-link :to="{name: 'SystemSettingsDelivery'}">
                        {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                      </router-link>
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.PrintMap"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.PrintMap ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col
                    class="pa-0 ma-0"
                    cols="12"
                  />

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.MapWidth.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.MapWidth.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-text-field
                      v-model="viewData.OrderDocument.MapWidth"
                      :disabled="!userCanManage"
                      class="elevation-0 d-inline-block ml-2"
                      dense
                      hide-details
                      min="0"
                      outlined
                      required
                      single-line
                      step="1"
                      style="min-width: 100px; max-width: 100px;"
                      suffix="mm"
                      type="number"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowQRCode.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowQRCode.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                    <div class="text-caption grey--text">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowQRCode.Hint')"
                        :search-text="langSearchText"
                        highlight
                      />
                      <router-link :to="{name: 'SystemSettingsDelivery'}">
                        {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                      </router-link>
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.PrintQR"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.PrintQR ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col
                    class="pa-0 ma-0"
                    cols="12"
                  />

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.QrWidth.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.QrWidth.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-text-field
                      v-model="viewData.OrderDocument.QrWidth"
                      :disabled="!userCanManage"
                      class="elevation-0 d-inline-block ml-2"
                      dense
                      hide-details
                      min="0"
                      outlined
                      required
                      single-line
                      step="1"
                      style="min-width: 100px; max-width: 100px;"
                      suffix="mm"
                      type="number"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowBarcode.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowBarcode.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.PrintBarcode"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.PrintBarcode ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowPrintSourceType.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowPrintSourceType.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.ShowPrintSourceType"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.ShowPrintSourceType ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.RespectWorkingHours.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.RespectWorkingHours.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.RespectWorkingHours"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.RespectWorkingHours ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowTaxes.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowTaxes.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.ShowTaxes"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.ShowTaxes ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowPrintOrderDailyNumber.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowPrintOrderDailyNumber.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.ShowPrintDailyCheck"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.ShowPrintDailyCheck ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowPrintNamesUppercase.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowPrintNamesUppercase.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.ShowPrintNamesUppercase"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.ShowPrintNamesUppercase ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowProductNumber.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowProductNumber.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.ShowProductNumber"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.ShowProductNumber ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowOrderTypeTime.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.ShowOrderTypeTime.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderDocument.ShowPrintOrderTypeTime"
                      :disabled="!userCanManage"
                      :label="viewData.OrderDocument.ShowPrintOrderTypeTime ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.MaxWidth.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.MaxWidth.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                    <div class="text-caption grey--text">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.MaxWidth.Hint')"
                        :search-text="langSearchText"
                        highlight
                      />
                      <router-link :to="{name: 'SystemSettingsPrinters'}">
                        {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                      </router-link>
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-text-field
                      v-model="viewData.OrderDocument.MaxWidth"
                      :disabled="!userCanManage"
                      :label="$t('Settings.Printer.Header.MaxWidth')"
                      class="elevation-0 d-inline-block ml-2"
                      dense
                      hide-details
                      min="0"
                      outlined
                      required
                      single-line
                      step="1"
                      style="min-width: 100px; max-width: 100px;"
                      suffix="mm"
                      type="number"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.FontSize.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.FontSize.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                    <div class="text-caption grey--text">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderDocument.FontSize.Hint')"
                        :search-text="langSearchText"
                        highlight
                      />
                      <router-link :to="{name: 'SystemSettingsPrinters'}">
                        {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                      </router-link>
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-text-field
                      v-model="viewData.OrderDocument.FontSize"
                      :disabled="!userCanManage"
                      :label="$t('Settings.Printer.Header.FontSize')"
                      class="elevation-0 d-inline-block ml-2"
                      dense
                      hide-details
                      min="0"
                      outlined
                      required
                      single-line
                      step="1"
                      style="min-width: 100px; max-width: 100px;"
                      suffix="pt"
                      type="number"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Preparation Document -->
          <v-expansion-panel :readonly="!viewData.PreparationDocument.Enabled">
            <v-expansion-panel-header :hide-actions="!viewData.PreparationDocument.Enabled">
              <div class="d-flex justify-start align-center">
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row
                    align="center"
                    dense
                  >
                    <v-col>
                      <v-icon class="pr-3">
                        {{ $t('Settings.Documents.PreparationDocument.Icon') }}
                      </v-icon>
                      <h5 class="d-inline-block text-body-2 font-weight-bold">
                        <lang-search-highlight
                          :lang-text="$t('Settings.Documents.PreparationDocument.Title')"
                          :search-text="langSearchText"
                          highlight
                        />
                      </h5>
                    </v-col>

                    <v-col class="shrink text-no-wrap">
                      <v-switch
                        v-model="viewData.PreparationDocument.Enabled"
                        :class="viewData.PreparationDocument.Enabled ? 'mr-8' : 'mr-10'"
                        :disabled="!userCanManage"
                        :label="viewData.PreparationDocument.Enabled ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                        class="ma-0 text-no-wrap"
                        color="success"
                        hide-details
                        inset
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expansion-panel-header>

            <v-divider />

            <v-expansion-panel-content>
              <v-container
                class="pa-0 py-2"
                fluid
              >
                <v-row
                  align="center"
                  dense
                >
                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.PreparationDocument.PrintPerMachine"
                      :disabled="!userCanManage"
                      :label="viewData.PreparationDocument.PrintPerMachine ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0 text-no-wrap"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.ShowItemPrice.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.ShowItemPrice.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.PreparationDocument.ShowItemPrice"
                      :disabled="!userCanManage"
                      :label="viewData.PreparationDocument.ShowItemPrice ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.ShowCategories.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.ShowCategories.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.PreparationDocument.ShowCategories"
                      :disabled="!userCanManage"
                      :label="viewData.PreparationDocument.ShowCategories ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.ShowOrderTime.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.ShowOrderTime.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.PreparationDocument.ShowOrderTime"
                      :disabled="!userCanManage"
                      :label="viewData.PreparationDocument.ShowOrderTime ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.ShowPrintNamesUppercase.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.ShowPrintNamesUppercase.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.PreparationDocument.ShowPrintNamesUppercase"
                      :disabled="!userCanManage"
                      :label="viewData.PreparationDocument.ShowPrintNamesUppercase ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.ShowProductNumber.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.ShowProductNumber.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.PreparationDocument.ShowProductNumber"
                      :disabled="!userCanManage"
                      :label="viewData.PreparationDocument.ShowProductNumber ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.MaxWidth.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.MaxWidth.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                    <div class="text-caption grey--text">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.MaxWidth.Hint')"
                        :search-text="langSearchText"
                        highlight
                      />
                      <router-link :to="{name: 'SystemSettingsPrinters'}">
                        {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                      </router-link>
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-text-field
                      v-model="viewData.PreparationDocument.MaxWidth"
                      :disabled="!userCanManage"
                      :label="$t('Settings.Printer.Header.MaxWidth')"
                      class="elevation-0 d-inline-block ml-2"
                      dense
                      hide-details
                      min="0"
                      outlined
                      required
                      single-line
                      step="1"
                      style="min-width: 100px; max-width: 100px;"
                      suffix="mm"
                      type="number"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.FontSize.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.FontSize.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                    <div class="text-caption grey--text">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.PreparationDocument.FontSize.Hint')"
                        :search-text="langSearchText"
                        highlight
                      />
                      <router-link :to="{name: 'SystemSettingsPrinters'}">
                        {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                      </router-link>
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-text-field
                      v-model="viewData.PreparationDocument.FontSize"
                      :disabled="!userCanManage"
                      :label="$t('Settings.Printer.Header.FontSize')"
                      class="elevation-0 d-inline-block ml-2"
                      dense
                      hide-details
                      min="0"
                      outlined
                      required
                      single-line
                      step="1"
                      style="min-width: 100px; max-width: 100px;"
                      suffix="pt"
                      type="number"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Marketing Document -->
          <v-expansion-panel :readonly="!viewData.MarketingDocument.Enabled">
            <v-expansion-panel-header :hide-actions="!viewData.MarketingDocument.Enabled">
              <div class="d-flex justify-start align-center">
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row
                    align="center"
                    dense
                  >
                    <v-col>
                      <v-icon class="pr-3">
                        {{ $t('Settings.Documents.MarketingDocument.Icon') }}
                      </v-icon>
                      <h5 class="d-inline-block text-body-2 font-weight-bold">
                        <lang-search-highlight
                          :lang-text="$t('Settings.Documents.MarketingDocument.Title')"
                          :search-text="langSearchText"
                          highlight
                        />
                      </h5>
                    </v-col>

                    <v-col class="shrink text-no-wrap">
                      <v-switch
                        v-model="viewData.MarketingDocument.Enabled"
                        :class="viewData.MarketingDocument.Enabled ? 'mr-8' : 'mr-10'"
                        :disabled="!userCanManage"
                        :label="viewData.MarketingDocument.Enabled ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                        class="ma-0 text-no-wrap"
                        color="success"
                        hide-details
                        inset
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expansion-panel-header>

            <v-divider />

            <v-expansion-panel-content>
              <v-container
                class="pa-0 py-2"
                fluid
              >
                <v-row
                  align="center"
                  dense
                >
                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.MarketingDocument.PrintPerMachine"
                      :disabled="!userCanManage"
                      :label="viewData.MarketingDocument.PrintPerMachine ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0 text-no-wrap"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.MarketingDocument.MaxWidth.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.MarketingDocument.MaxWidth.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                    <div class="text-caption grey--text">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.MarketingDocument.MaxWidth.Hint')"
                        :search-text="langSearchText"
                        highlight
                      />
                      <router-link :to="{name: 'SystemSettingsPrinters'}">
                        {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                      </router-link>
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-text-field
                      v-model="viewData.MarketingDocument.MaxWidth"
                      :disabled="!userCanManage"
                      :label="$t('Settings.Printer.Header.MaxWidth')"
                      class="elevation-0 d-inline-block ml-2"
                      dense
                      hide-details
                      min="0"
                      outlined
                      required
                      single-line
                      step="1"
                      style="min-width: 100px; max-width: 100px;"
                      suffix="mm"
                      type="number"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Order Receipt -->
          <v-expansion-panel v-if="receiptsActive">
            <v-expansion-panel-header>
              <div class="d-flex justify-start align-center">
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row
                    align="center"
                  >
                    <v-col>
                      <v-icon class="pr-3">
                        {{ $t('Settings.Documents.OrderReceipt.Icon') }}
                      </v-icon>
                      <h5 class="d-inline-block text-body-2 font-weight-bold">
                        <lang-search-highlight
                          :lang-text="$t('Settings.Documents.OrderReceipt.Title')"
                          :search-text="langSearchText"
                          highlight
                        />
                      </h5>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expansion-panel-header>

            <v-divider />

            <v-expansion-panel-content>
              <v-container
                class="pa-0 py-2"
                fluid
              >
                <v-row dense>
                  <v-col cols="12" />
                </v-row>

                <v-expansion-panels
                  v-model="docsExpansionPanel"
                  flat
                  focusable
                >
                  <!-- Receipt Sale 11.1 -->
                  <v-expansion-panel :readonly="!viewData.OrderReceipt.Enabled">
                    <v-expansion-panel-header
                      :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT)"
                      :hide-actions="!viewData.OrderReceipt.Enabled"
                      class="white--text mb-1 rounded"
                    >
                      <div class="d-flex justify-start align-center">
                        <v-icon
                          :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT, false, true)"
                          class="pr-3"
                          dark
                        >
                          {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT) }}
                        </v-icon>
                        <h5 class="text-body-2 font-weight-bold">
                          <lang-search-highlight
                            :lang-text="$t('Settings.Documents.OrderReceipt.Document.Receipt')"
                            :search-text="langSearchText"
                            highlight
                          />
                        </h5>

                        <v-spacer />

                        <v-switch
                          v-model="viewData.OrderReceipt.Enabled"
                          :class="viewData.OrderReceipt.Enabled ? 'mr-8' : 'mr-10'"
                          :disabled="!userCanManage"
                          :label="viewData.OrderReceipt.Enabled ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                          class="ma-0 text-no-wrap"
                          color="white"
                          dark
                          hide-details
                          inset
                        />
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-container
                        class="px-0 py-2"
                        fluid
                      >
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.Series.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.Series.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.Series"
                              :disabled="viewData.OrderReceipt.HasReceipts"
                              :hide-details="viewData.OrderReceipt.HasReceipts"
                              dense
                              outlined
                              required
                              single-line
                              style="min-width: 100px; max-width: 100px;"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInit.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInit.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.TotalCheckInit"
                              :disabled="viewData.OrderReceipt.HasReceipts"
                              :hide-details="viewData.OrderReceipt.HasReceipts"
                              :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.TotalCheckInit.Error.InvalidNumber')]"
                              dense
                              outlined
                              required
                              single-line
                              style="min-width: 100px; max-width: 100px;"
                              type="number"
                              @focusout="onTotalReceiptCheckInitFocusOut"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.Notify.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.Notify.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-btn-toggle
                              v-model="viewData.OrderReceipt.Notify"
                              color="success"
                              multiple
                            >
                              <v-btn
                                text
                                value="print"
                              >
                                {{ $t('Settings.Documents.OrderReceipt.Notify.Print').toLocaleUpperCase($i18n.locale) }}
                              </v-btn>

                              <v-btn
                                :disabled="!appFiscalDocsProviderNotify.includes(NotifyTypeEnum.EMAIL)"
                                text
                                value="email"
                              >
                                {{ $t('Settings.Documents.OrderReceipt.Notify.Email').toLocaleUpperCase($i18n.locale) }}
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowCashChange.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowCashChange.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowPrintCashChange"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowPrintCashChange ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowPrintSoldItems.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowPrintSoldItems.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowPrintSoldItems"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowPrintSoldItems ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowPrintItemBarcode.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowPrintItemBarcode.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowPrintItemBarcode"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowPrintItemBarcode ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowPrintNamesUppercase.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowPrintNamesUppercase.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowPrintNamesUppercase"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowPrintNamesUppercase ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.PrintPerMachine"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.PrintPerMachine ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.AutoGenerate.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.AutoGenerate.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.AutoGenerate"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.AutoGenerate ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>
                          <v-col
                            class="pa-0 ma-0"
                            cols="12"
                          />

                          <template v-if="viewData.OrderReceipt.AutoGenerate">
                            <v-col cols="12">
                              <v-simple-table>
                                <template #default>
                                  <thead>
                                    <tr>
                                      <th
                                        class="text-left"
                                        style="width: 200px;"
                                      >
                                        {{ $t('Restaurant.CatalogAddDialog.Field.OrderStatus.Label') }}
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td class="pa-2">
                                        <v-select
                                          v-model="viewData.OrderReceipt.StatusAutoGenerate"
                                          :items="orderStatusesFiltered"
                                          :label="$t('Restaurant.CatalogAddDialog.Field.OrderStatus.Label')"
                                          class="d-inline-flex"
                                          dense
                                          hide-details
                                          item-text="Name"
                                          item-value="Id"
                                          outlined
                                          single-line
                                          style="max-width: 180px;"
                                        >
                                          <template #selection="{item}">
                                            <v-chip
                                              :color="item.Status ? 'green' : ''"
                                              :dark="item.Status"
                                              class="pl-0"
                                              label
                                              small
                                              style="width: 100%;"
                                            >
                                              <v-avatar
                                                :color="item.Avatar.Color"
                                                class="mr-2"
                                                tile
                                              >
                                                <v-icon class="white--text">
                                                  {{ item.Avatar.Icon }}
                                                </v-icon>
                                              </v-avatar>
                                              <span>{{ item.Name }}</span>
                                            </v-chip>
                                          </template>

                                          <template #item="data">
                                            <v-list-item-avatar :color="data.item.Avatar.Color">
                                              <v-icon dark>
                                                {{ data.item.Avatar.Icon }}
                                              </v-icon>
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                              <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                            </v-list-item-content>
                                          </template>
                                        </v-select>
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>

                            <v-col cols="12">
                              <v-simple-table>
                                <template #default>
                                  <thead>
                                    <tr>
                                      <th
                                        class="text-left"
                                        style="width: 200px;"
                                      >
                                        {{ $t('Order.SourceType.Title') }}
                                      </th>

                                      <th
                                        class="text-left"
                                        style="width: 280px;"
                                      >
                                        {{ $t('Order.Type.Title') }}
                                      </th>

                                      <th class="text-left">
                                        {{ $t('Common.Button.Toggle.ActiveF') }}
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <template v-for="(sourceType, sourceTypeIdx) in viewData.OrderReceipt.SourcesAutoGenerate">
                                      <tr
                                        v-if="(sourceType.id === 0 && sourceType.active) || (!viewData.OrderReceipt.SourcesAutoGenerate[0].active)"
                                        :key="`source-type-${sourceTypeIdx}`"
                                      >
                                        <td class="pa-2">
                                          <v-chip
                                            :color="getSourceTypeById(sourceType.id).Status ? 'green' : ''"
                                            :dark="getSourceTypeById(sourceType.id).Status"
                                            class="pl-0"
                                            label
                                            style="width: 240px; height: 40px;"
                                          >
                                            <v-avatar
                                              :color="getSourceTypeById(sourceType.id).Avatar.Color"
                                              class="mr-2"
                                              style="width: 40px !important; height: 40px !important;"
                                              tile
                                            >
                                              <v-icon
                                                v-if="getSourceTypeById(sourceType.id).Avatar.Icon"
                                                class="white--text"
                                              >
                                                {{ getSourceTypeById(sourceType.id).Avatar.Icon }}
                                              </v-icon>

                                              <img
                                                v-else
                                                :src="getSourceTypeById(sourceType.id).Avatar.Img"
                                              >
                                            </v-avatar>
                                            <span>{{ getSourceTypeById(sourceType.id).Name }}</span>
                                          </v-chip>
                                        </td>

                                        <td class="pa-2">
                                          <v-select
                                            v-model="sourceType.orderType"
                                            :disabled="sourceType.id === 0"
                                            :items="orderTypesListFiltered"
                                            :label="$t('Restaurant.CatalogAddDialog.Field.OrderType.Label')"
                                            class="pt-0"
                                            dense
                                            hide-details
                                            item-text="Name"
                                            item-value="Id"
                                            outlined
                                            single-line
                                            style="max-width: 260px;"
                                          >
                                            <template #selection="{item}">
                                              <v-chip
                                                :color="item.Status ? 'green' : ''"
                                                :dark="item.Status"
                                                class="pl-0"
                                                label
                                                small
                                                style="width: 100%;"
                                              >
                                                <v-avatar
                                                  :color="item.Color"
                                                  class="mr-2"
                                                  tile
                                                >
                                                  <v-icon class="white--text">
                                                    {{ item.Icon }}
                                                  </v-icon>
                                                </v-avatar>
                                                <span>{{ item.Name }}</span>
                                              </v-chip>
                                            </template>

                                            <template #item="data">
                                              <v-list-item-avatar :color="data.item.Color">
                                                <v-icon dark>
                                                  {{ data.item.Icon }}
                                                </v-icon>
                                              </v-list-item-avatar>

                                              <v-list-item-content>
                                                <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                              </v-list-item-content>
                                            </template>
                                          </v-select>
                                        </td>

                                        <td class="pa-2">
                                          <v-switch
                                            v-model="sourceType.active"
                                            :disabled="!userCanManage"
                                            class="ma-0 pa-0 d-inline-flex"
                                            color="success"
                                            hide-details
                                            inset
                                            @change="onSourceOrderTypeChange(sourceType)"
                                          />
                                        </td>
                                      </tr>
                                    </template>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>
                          </template>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" />
                        </v-row>

                        <!-- Receipt Credit -->
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col cols="12">
                            <v-card flat>
                              <v-card-title :class="[receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT)]">
                                <div class="d-flex justify-start align-center">
                                  <v-icon
                                    :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT, false, true)"
                                    class="pr-3"
                                    dark
                                  >
                                    {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT) }}
                                  </v-icon>
                                  <h5 class="text-body-2 font-weight-bold white--text">
                                    {{ $t('Settings.Documents.OrderReceipt.Document.ReceiptCredit') }}
                                  </h5>
                                </div>

                                <v-spacer />
                              </v-card-title>

                              <v-divider />

                              <v-card-text class="px-2">
                                <v-container
                                  class="pa-0"
                                  fluid
                                >
                                  <v-row
                                    align="center"
                                    dense
                                  >
                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.SeriesCredit.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.SeriesCredit.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.CreditSeries"
                                        :disabled="viewData.OrderReceipt.HasReceiptsCredit"
                                        :hide-details="viewData.OrderReceipt.HasReceiptsCredit"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                      />
                                    </v-col>

                                    <v-col cols="12">
                                      <v-divider class="" />
                                    </v-col>

                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.TotalCreditCheckInit"
                                        :disabled="viewData.OrderReceipt.HasReceiptsCredit"
                                        :hide-details="viewData.OrderReceipt.HasReceiptsCredit"
                                        :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Error.InvalidNumber')]"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                        type="number"
                                        @focusout="onTotalCreditReceiptCheckInitFocusOut"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- Receipt Service 11.2 -->
                  <v-expansion-panel :readonly="!viewData.OrderReceipt.ServiceEnabled">
                    <v-expansion-panel-header
                      :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT)"
                      :hide-actions="!viewData.OrderReceipt.ServiceEnabled"
                      class="white--text mb-1 rounded"
                    >
                      <div class="d-flex justify-start align-center">
                        <v-icon
                          :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT, false, true)"
                          class="pr-3"
                          dark
                        >
                          {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT) }}
                        </v-icon>
                        <h5 class="text-body-2 font-weight-bold">
                          <lang-search-highlight
                            :lang-text="$t('Settings.Documents.OrderReceipt.Document.ServiceReceipt')"
                            :search-text="langSearchText"
                            highlight
                          />
                        </h5>

                        <v-spacer />

                        <v-switch
                          v-model="viewData.OrderReceipt.ServiceEnabled"
                          :class="viewData.OrderReceipt.ServiceEnabled ? 'mr-8' : 'mr-10'"
                          :disabled="!userCanManage"
                          :label="viewData.OrderReceipt.ServiceEnabled ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                          class="ma-0 text-no-wrap"
                          color="white"
                          dark
                          hide-details
                          inset
                        />
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-container
                        class="px-0 py-2"
                        fluid
                      >
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.Series.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.Series.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.ServiceSeries"
                              :disabled="viewData.OrderReceipt.HasServiceReceipts"
                              :hide-details="viewData.OrderReceipt.HasServiceReceipts"
                              dense
                              outlined
                              required
                              single-line
                              style="min-width: 100px; max-width: 100px;"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInit.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInit.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.ServiceTotalCheckInit"
                              :disabled="viewData.OrderReceipt.HasServiceReceipts"
                              :hide-details="viewData.OrderReceipt.HasServiceReceipts"
                              :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.TotalCheckInit.Error.InvalidNumber')]"
                              dense
                              outlined
                              required
                              single-line
                              style="min-width: 100px; max-width: 100px;"
                              type="number"
                              @focusout="onTotalServiceReceiptCheckInitFocusOut"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.Notify.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.Notify.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-btn-toggle
                              v-model="viewData.OrderReceipt.ServiceNotify"
                              color="success"
                              multiple
                            >
                              <v-btn
                                text
                                value="print"
                              >
                                {{ $t('Settings.Documents.OrderReceipt.Notify.Print').toLocaleUpperCase($i18n.locale) }}
                              </v-btn>

                              <v-btn
                                :disabled="!appFiscalDocsProviderNotify.includes(NotifyTypeEnum.EMAIL)"
                                text
                                value="email"
                              >
                                {{ $t('Settings.Documents.OrderReceipt.Notify.Email').toLocaleUpperCase($i18n.locale) }}
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ServicePrintPerMachine"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ServicePrintPerMachine ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.AutoGenerate.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.AutoGenerate.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ServiceAutoGenerate"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ServiceAutoGenerate ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>
                          <v-col
                            class="pa-0 ma-0"
                            cols="12"
                          />

                          <template v-if="viewData.OrderReceipt.ServiceAutoGenerate">
                            <v-col cols="12">
                              <v-simple-table>
                                <template #default>
                                  <thead>
                                    <tr>
                                      <th
                                        class="text-left"
                                        style="width: 200px;"
                                      >
                                        {{ $t('Restaurant.CatalogAddDialog.Field.OrderStatus.Label') }}
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td class="pa-2">
                                        <v-select
                                          v-model="viewData.OrderReceipt.ServiceStatusAutoGenerate"
                                          :items="orderStatusesFiltered"
                                          :label="$t('Restaurant.CatalogAddDialog.Field.OrderStatus.Label')"
                                          class="d-inline-flex"
                                          dense
                                          hide-details
                                          item-text="Name"
                                          item-value="Id"
                                          outlined
                                          single-line
                                          style="max-width: 180px;"
                                        >
                                          <template #selection="{item}">
                                            <v-chip
                                              :color="item.Status ? 'green' : ''"
                                              :dark="item.Status"
                                              class="pl-0"
                                              label
                                              small
                                              style="width: 100%;"
                                            >
                                              <v-avatar
                                                :color="item.Avatar.Color"
                                                class="mr-2"
                                                tile
                                              >
                                                <v-icon class="white--text">
                                                  {{ item.Avatar.Icon }}
                                                </v-icon>
                                              </v-avatar>
                                              <span>{{ item.Name }}</span>
                                            </v-chip>
                                          </template>

                                          <template #item="data">
                                            <v-list-item-avatar :color="data.item.Avatar.Color">
                                              <v-icon dark>
                                                {{ data.item.Avatar.Icon }}
                                              </v-icon>
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                              <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                            </v-list-item-content>
                                          </template>
                                        </v-select>
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>

                            <v-col cols="12">
                              <v-simple-table>
                                <template #default>
                                  <thead>
                                    <tr>
                                      <th
                                        class="text-left"
                                        style="width: 200px;"
                                      >
                                        {{ $t('Order.SourceType.Title') }}
                                      </th>

                                      <th
                                        class="text-left"
                                        style="width: 280px;"
                                      >
                                        {{ $t('Order.Type.Title') }}
                                      </th>

                                      <th class="text-left">
                                        {{ $t('Common.Button.Toggle.ActiveF') }}
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <template v-for="(sourceType, sourceTypeIdx) in viewData.OrderReceipt.ServiceSourcesAutoGenerate">
                                      <tr
                                        v-if="(sourceType.id === 0 && sourceType.active) || (!viewData.OrderReceipt.ServiceSourcesAutoGenerate[0].active)"
                                        :key="`source-type-${sourceTypeIdx}`"
                                      >
                                        <td class="pa-2">
                                          <v-chip
                                            :color="getSourceTypeById(sourceType.id).Status ? 'green' : ''"
                                            :dark="getSourceTypeById(sourceType.id).Status"
                                            class="pl-0"
                                            label
                                            style="width: 180px; height: 40px;"
                                          >
                                            <v-avatar
                                              :color="getSourceTypeById(sourceType.id).Avatar.Color"
                                              class="mr-2"
                                              style="width: 40px !important; height: 40px !important;"
                                              tile
                                            >
                                              <v-icon
                                                v-if="getSourceTypeById(sourceType.id).Avatar.Icon"
                                                class="white--text"
                                              >
                                                {{ getSourceTypeById(sourceType.id).Avatar.Icon }}
                                              </v-icon>

                                              <img
                                                v-else
                                                :src="getSourceTypeById(sourceType.id).Avatar.Img"
                                              >
                                            </v-avatar>
                                            <span>{{ getSourceTypeById(sourceType.id).Name }}</span>
                                          </v-chip>
                                        </td>

                                        <td class="pa-2">
                                          <v-select
                                            v-model="sourceType.orderType"
                                            :disabled="sourceType.id === 0"
                                            :items="orderTypesListFiltered"
                                            :label="$t('Restaurant.CatalogAddDialog.Field.OrderType.Label')"
                                            class="pt-0"
                                            dense
                                            hide-details
                                            item-text="Name"
                                            item-value="Id"
                                            outlined
                                            single-line
                                            style="max-width: 260px;"
                                          >
                                            <template #selection="{item}">
                                              <v-chip
                                                :color="item.Status ? 'green' : ''"
                                                :dark="item.Status"
                                                class="pl-0"
                                                label
                                                small
                                                style="width: 100%;"
                                              >
                                                <v-avatar
                                                  :color="item.Color"
                                                  class="mr-2"
                                                  tile
                                                >
                                                  <v-icon class="white--text">
                                                    {{ item.Icon }}
                                                  </v-icon>
                                                </v-avatar>
                                                <span>{{ item.Name }}</span>
                                              </v-chip>
                                            </template>

                                            <template #item="data">
                                              <v-list-item-avatar :color="data.item.Color">
                                                <v-icon dark>
                                                  {{ data.item.Icon }}
                                                </v-icon>
                                              </v-list-item-avatar>

                                              <v-list-item-content>
                                                <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                              </v-list-item-content>
                                            </template>
                                          </v-select>
                                        </td>

                                        <td class="pa-2">
                                          <v-switch
                                            v-model="sourceType.active"
                                            :disabled="!userCanManage"
                                            class="ma-0 pa-0 d-inline-flex"
                                            color="success"
                                            hide-details
                                            inset
                                            @change="onSourceOrderTypeChange(sourceType)"
                                          />
                                        </td>
                                      </tr>
                                    </template>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>
                          </template>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" />
                        </v-row>

                        <!-- Receipt Credit Service -->
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col cols="12">
                            <v-card flat>
                              <v-card-title :class="[receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT)]">
                                <div class="d-flex justify-start align-center">
                                  <v-icon
                                    :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT, false, true)"
                                    class="pr-3"
                                    dark
                                  >
                                    {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT) }}
                                  </v-icon>
                                  <h5 class="text-body-2 font-weight-bold white--text">
                                    <lang-search-highlight
                                      :lang-text="$t('Settings.Documents.OrderReceipt.Document.ServiceReceiptCredit')"
                                      :search-text="langSearchText"
                                      highlight
                                    />
                                  </h5>
                                </div>

                                <v-spacer />
                              </v-card-title>

                              <v-divider />

                              <v-card-text class="px-2">
                                <v-container
                                  class="pa-0"
                                  fluid
                                >
                                  <v-row
                                    align="center"
                                    dense
                                  >
                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.SeriesCredit.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.SeriesCredit.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.ServiceCreditSeries"
                                        :disabled="viewData.OrderReceipt.HasServiceReceiptsCredit"
                                        :hide-details="viewData.OrderReceipt.HasServiceReceiptsCredit"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                      />
                                    </v-col>

                                    <v-col cols="12">
                                      <v-divider class="" />
                                    </v-col>

                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.ServiceTotalCreditCheckInit"
                                        :disabled="viewData.OrderReceipt.HasServiceReceiptsCredit"
                                        :hide-details="viewData.OrderReceipt.HasServiceReceiptsCredit"
                                        :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Error.InvalidNumber')]"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                        type="number"
                                        @focusout="onTotalServiceCreditReceiptCheckInitFocusOut"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- Receipt Self Supply 6.1 -->
                  <template v-if="userIsSuperAdmin">
                    <v-expansion-panel :readonly="!viewData.OrderReceipt.SelfSupplyEnabled">
                      <v-expansion-panel-header
                        :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_SUPPLY)"
                        :hide-actions="!viewData.OrderReceipt.SelfSupplyEnabled"
                        class="white--text mb-1 rounded"
                      >
                        <div class="d-flex justify-start align-center">
                          <v-icon
                            :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CASH_POS, false, true)"
                            class="pr-3"
                            dark
                          >
                            {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_SUPPLY) }}
                          </v-icon>
                          <h5 class="text-body-2 font-weight-bold">
                            <lang-search-highlight
                              :lang-text="$t('Settings.Documents.OrderReceipt.Document.SelfSupplyReceipt')"
                              :search-text="langSearchText"
                              highlight
                            />
                          </h5>

                          <v-spacer />

                          <v-switch
                            v-model="viewData.OrderReceipt.SelfSupplyEnabled"
                            :class="viewData.OrderReceipt.SelfSupplyEnabled ? 'mr-8' : 'mr-10'"
                            :disabled="!userCanManage"
                            :label="viewData.OrderReceipt.SelfSupplyEnabled ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                            class="ma-0 text-no-wrap"
                            color="white"
                            dark
                            hide-details
                            inset
                          />
                        </div>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <v-container
                          class="px-0 py-2"
                          fluid
                        >
                          <v-row
                            align="center"
                            dense
                          >
                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Series.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Series.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-text-field
                                v-model="viewData.OrderReceipt.SelfSupplyDocumentSeries"
                                :disabled="viewData.OrderReceipt.HasReceiptsSelfSupply"
                                :hide-details="viewData.OrderReceipt.HasReceiptsSelfSupply"
                                dense
                                outlined
                                required
                                single-line
                                style="min-width: 100px; max-width: 100px;"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="" />
                            </v-col>

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInit.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInit.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-text-field
                                v-model="viewData.OrderReceipt.SelfSupplyTotalCheckInit"
                                :disabled="viewData.OrderReceipt.HasReceiptsSelfSupply"
                                :hide-details="viewData.OrderReceipt.HasReceiptsSelfSupply"
                                :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.TotalCheckInit.Error.InvalidNumber')]"
                                dense
                                outlined
                                required
                                single-line
                                style="min-width: 100px; max-width: 100px;"
                                type="number"
                                @focusout="onTotalSelfSupplyReceiptCheckInitFocusOut"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="" />
                            </v-col>

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Notify.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Notify.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-btn-toggle
                                v-model="viewData.OrderReceipt.SelfSupplyNotify"
                                color="success"
                                multiple
                              >
                                <v-btn
                                  text
                                  value="print"
                                >
                                  {{ $t('Settings.Documents.OrderReceipt.Notify.Print').toLocaleUpperCase($i18n.locale) }}
                                </v-btn>

                                <v-btn
                                  :disabled="!appFiscalDocsProviderNotify.includes(NotifyTypeEnum.EMAIL)"
                                  text
                                  value="email"
                                >
                                  {{ $t('Settings.Documents.OrderReceipt.Notify.Email').toLocaleUpperCase($i18n.locale) }}
                                </v-btn>
                              </v-btn-toggle>
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="" />
                            </v-col>

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-switch
                                v-model="viewData.OrderReceipt.SelfSupplyPrintPerMachine"
                                :disabled="!userCanManage"
                                :label="viewData.OrderReceipt.SelfSupplyPrintPerMachine ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                                class="ma-0 text-no-wrap"
                                color="success"
                                hide-details
                                inset
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="" />
                            </v-col>

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.AutoGenerate.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.AutoGenerate.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-switch
                                v-model="viewData.OrderReceipt.SelfSupplyAutoGenerate"
                                :disabled="!userCanManage"
                                :label="viewData.OrderReceipt.SelfSupplyAutoGenerate ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                                class="ma-0 text-no-wrap"
                                color="success"
                                hide-details
                                inset
                              />
                            </v-col>
                            <v-col
                              class="pa-0 ma-0"
                              cols="12"
                            />

                            <template v-if="viewData.OrderReceipt.SelfSupplyAutoGenerate">
                              <v-col cols="12">
                                <v-simple-table>
                                  <template #default>
                                    <thead>
                                      <tr>
                                        <th
                                          class="text-left"
                                          style="width: 200px;"
                                        >
                                          {{ $t('Restaurant.CatalogAddDialog.Field.OrderStatus.Label') }}
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <tr>
                                        <td class="pa-2">
                                          <v-select
                                            v-model="viewData.OrderReceipt.SelfSupplyStatusAutoGenerate"
                                            :items="orderStatusesFiltered"
                                            :label="$t('Restaurant.CatalogAddDialog.Field.OrderStatus.Label')"
                                            class="d-inline-flex"
                                            dense
                                            hide-details
                                            item-text="Name"
                                            item-value="Id"
                                            outlined
                                            single-line
                                            style="max-width: 180px;"
                                          >
                                            <template #selection="{item}">
                                              <v-chip
                                                :color="item.Status ? 'green' : ''"
                                                :dark="item.Status"
                                                class="pl-0"
                                                label
                                                small
                                                style="width: 100%;"
                                              >
                                                <v-avatar
                                                  :color="item.Avatar.Color"
                                                  class="mr-2"
                                                  tile
                                                >
                                                  <v-icon class="white--text">
                                                    {{ item.Avatar.Icon }}
                                                  </v-icon>
                                                </v-avatar>
                                                <span>{{ item.Name }}</span>
                                              </v-chip>
                                            </template>

                                            <template #item="data">
                                              <v-list-item-avatar :color="data.item.Avatar.Color">
                                                <v-icon dark>
                                                  {{ data.item.Avatar.Icon }}
                                                </v-icon>
                                              </v-list-item-avatar>

                                              <v-list-item-content>
                                                <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                              </v-list-item-content>
                                            </template>
                                          </v-select>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-col>

                              <v-col cols="12">
                                <v-simple-table>
                                  <template #default>
                                    <thead>
                                      <tr>
                                        <th
                                          class="text-left"
                                          style="width: 200px;"
                                        >
                                          {{ $t('Order.SourceType.Title') }}
                                        </th>

                                        <th
                                          class="text-left"
                                          style="width: 280px;"
                                        >
                                          {{ $t('Order.Type.Title') }}
                                        </th>

                                        <th class="text-left">
                                          {{ $t('Common.Button.Toggle.ActiveF') }}
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <template v-for="(sourceType, sourceTypeIdx) in viewData.OrderReceipt.SelfSupplySourcesAutoGenerate">
                                        <tr
                                          v-if="(sourceType.id === 0 && sourceType.active) || (!viewData.OrderReceipt.SelfSupplySourcesAutoGenerate[0]?.active)"
                                          :key="`source-type-${sourceTypeIdx}`"
                                        >
                                          <td class="pa-2">
                                            <v-chip
                                              :color="getSourceTypeById(sourceType.id).Status ? 'green' : ''"
                                              :dark="getSourceTypeById(sourceType.id).Status"
                                              class="pl-0"
                                              label
                                              style="width: 180px; height: 40px;"
                                            >
                                              <v-avatar
                                                :color="getSourceTypeById(sourceType.id).Avatar.Color"
                                                class="mr-2"
                                                style="width: 40px !important; height: 40px !important;"
                                                tile
                                              >
                                                <v-icon
                                                  v-if="getSourceTypeById(sourceType.id).Avatar.Icon"
                                                  class="white--text"
                                                >
                                                  {{ getSourceTypeById(sourceType.id).Avatar.Icon }}
                                                </v-icon>

                                                <img
                                                  v-else
                                                  :src="getSourceTypeById(sourceType.id).Avatar.Img"
                                                >
                                              </v-avatar>
                                              <span>{{ getSourceTypeById(sourceType.id).Name }}</span>
                                            </v-chip>
                                          </td>

                                          <td class="pa-2">
                                            <v-select
                                              v-model="sourceType.orderType"
                                              :disabled="sourceType.id === 0"
                                              :items="orderTypesListFiltered"
                                              :label="$t('Restaurant.CatalogAddDialog.Field.OrderType.Label')"
                                              class="pt-0"
                                              dense
                                              hide-details
                                              item-text="Name"
                                              item-value="Id"
                                              outlined
                                              single-line
                                              style="max-width: 260px;"
                                            >
                                              <template #selection="{item}">
                                                <v-chip
                                                  :color="item.Status ? 'green' : ''"
                                                  :dark="item.Status"
                                                  class="pl-0"
                                                  label
                                                  small
                                                  style="width: 100%;"
                                                >
                                                  <v-avatar
                                                    :color="item.Color"
                                                    class="mr-2"
                                                    tile
                                                  >
                                                    <v-icon class="white--text">
                                                      {{ item.Icon }}
                                                    </v-icon>
                                                  </v-avatar>
                                                  <span>{{ item.Name }}</span>
                                                </v-chip>
                                              </template>

                                              <template #item="data">
                                                <v-list-item-avatar :color="data.item.Color">
                                                  <v-icon dark>
                                                    {{ data.item.Icon }}
                                                  </v-icon>
                                                </v-list-item-avatar>

                                                <v-list-item-content>
                                                  <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                                </v-list-item-content>
                                              </template>
                                            </v-select>
                                          </td>

                                          <td class="pa-2">
                                            <v-switch
                                              v-model="sourceType.active"
                                              :disabled="!userCanManage"
                                              class="ma-0 pa-0 d-inline-flex"
                                              color="success"
                                              hide-details
                                              inset
                                              @change="onSourceOrderTypeChangeSelfSupply(sourceType)"
                                            />
                                          </td>
                                        </tr>
                                      </template>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-col>
                            </template>
                          </v-row>

                          <v-row dense>
                            <v-col cols="12" />
                          </v-row>

                          <!-- Receipt Return 8.5 -->
                          <v-row
                            align="center"
                            dense
                          >
                            <v-col cols="12">
                              <v-card flat>
                                <v-card-title :class="[receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS)]">
                                  <div class="d-flex justify-start align-center">
                                    <v-icon
                                      :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS, false, true)"
                                      class="pr-3"
                                      dark
                                    >
                                      {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS) }}
                                    </v-icon>
                                    <h5 class="text-body-2 font-weight-bold white--text">
                                      <lang-search-highlight
                                        :lang-text="$t('Settings.Documents.OrderReceipt.Document.ReturnReceipt')"
                                        :search-text="langSearchText"
                                        highlight
                                      />
                                    </h5>
                                  </div>

                                  <v-spacer />
                                </v-card-title>

                                <v-divider />

                                <v-card-text class="px-2">
                                  <v-container
                                    class="pa-0"
                                    fluid
                                  >
                                    <v-row
                                      align="center"
                                      dense
                                    >
                                      <v-col>
                                        <h5 class="text-body-2 font-weight-bold">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.SeriesCredit.Title')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </h5>
                                        <div class="text-caption">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.SeriesCredit.Subtitle')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </div>
                                      </v-col>
                                      <v-col class="shrink">
                                        <v-text-field
                                          v-model="viewData.OrderReceipt.SelfSupplyCreditSeries"
                                          :disabled="viewData.OrderReceipt.HasReceiptsSelfSupplyCredit"
                                          :hide-details="viewData.OrderReceipt.HasReceiptsSelfSupplyCredit"
                                          dense
                                          outlined
                                          required
                                          single-line
                                          style="min-width: 100px; max-width: 100px;"
                                        />
                                      </v-col>

                                      <v-col cols="12">
                                        <v-divider class="" />
                                      </v-col>

                                      <v-col>
                                        <h5 class="text-body-2 font-weight-bold">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Title')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </h5>
                                        <div class="text-caption">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Subtitle')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </div>
                                      </v-col>
                                      <v-col class="shrink">
                                        <v-text-field
                                          v-model="viewData.OrderReceipt.SelfSupplyTotalCreditCheckInit"
                                          :disabled="viewData.OrderReceipt.HasReceiptsSelfSupplyCredit"
                                          :hide-details="viewData.OrderReceipt.HasReceiptsSelfSupplyCredit"
                                          :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Error.InvalidNumber')]"
                                          dense
                                          outlined
                                          required
                                          single-line
                                          style="min-width: 100px; max-width: 100px;"
                                          type="number"
                                          @focusout="onTotalSelfSupplyReturnReceiptCheckInitFocusOut"
                                        />
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </template>

                  <!-- Receipt Self Use 6.2 -->
                  <template v-if="userIsSuperAdmin">
                    <v-expansion-panel :readonly="!viewData.OrderReceipt.SelfUseEnabled">
                      <v-expansion-panel-header
                        :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_USE)"
                        :hide-actions="!viewData.OrderReceipt.SelfUseEnabled"
                        class="white--text mb-1 rounded"
                      >
                        <div class="d-flex justify-start align-center">
                          <v-icon
                            :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CASH_POS, false, true)"
                            class="pr-3"
                            dark
                          >
                            {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_USE) }}
                          </v-icon>
                          <h5 class="text-body-2 font-weight-bold">
                            <lang-search-highlight
                              :lang-text="$t('Settings.Documents.OrderReceipt.Document.SelfUseReceipt')"
                              :search-text="langSearchText"
                              highlight
                            />
                          </h5>

                          <v-spacer />

                          <v-switch
                            v-model="viewData.OrderReceipt.SelfUseEnabled"
                            :class="viewData.OrderReceipt.SelfUseEnabled ? 'mr-8' : 'mr-10'"
                            :disabled="!userCanManage"
                            :label="viewData.OrderReceipt.SelfUseEnabled ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                            class="ma-0 text-no-wrap"
                            color="white"
                            dark
                            hide-details
                            inset
                          />
                        </div>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <v-container
                          class="px-0 py-2"
                          fluid
                        >
                          <v-row
                            align="center"
                            dense
                          >
                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Series.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Series.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-text-field
                                v-model="viewData.OrderReceipt.SelfUseDocumentSeries"
                                :disabled="viewData.OrderReceipt.HasReceiptsSelfUse"
                                :hide-details="viewData.OrderReceipt.HasReceiptsSelfUse"
                                dense
                                outlined
                                required
                                single-line
                                style="min-width: 100px; max-width: 100px;"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="" />
                            </v-col>

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInit.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInit.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-text-field
                                v-model="viewData.OrderReceipt.SelfUseTotalCheckInit"
                                :disabled="viewData.OrderReceipt.HasReceiptsSelfUse"
                                :hide-details="viewData.OrderReceipt.HasReceiptsSelfUse"
                                :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.TotalCheckInit.Error.InvalidNumber')]"
                                dense
                                outlined
                                required
                                single-line
                                style="min-width: 100px; max-width: 100px;"
                                type="number"
                                @focusout="onTotalSelfUseReceiptCheckInitFocusOut"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="" />
                            </v-col>

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Notify.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Notify.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-btn-toggle
                                v-model="viewData.OrderReceipt.SelfUseNotify"
                                color="success"
                                multiple
                              >
                                <v-btn
                                  text
                                  value="print"
                                >
                                  {{ $t('Settings.Documents.OrderReceipt.Notify.Print').toLocaleUpperCase($i18n.locale) }}
                                </v-btn>

                                <v-btn
                                  :disabled="!appFiscalDocsProviderNotify.includes(NotifyTypeEnum.EMAIL)"
                                  text
                                  value="email"
                                >
                                  {{ $t('Settings.Documents.OrderReceipt.Notify.Email').toLocaleUpperCase($i18n.locale) }}
                                </v-btn>
                              </v-btn-toggle>
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="" />
                            </v-col>

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-switch
                                v-model="viewData.OrderReceipt.SelfUsePrintPerMachine"
                                :disabled="!userCanManage"
                                :label="viewData.OrderReceipt.SelfUsePrintPerMachine ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                                class="ma-0 text-no-wrap"
                                color="success"
                                hide-details
                                inset
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="" />
                            </v-col>

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.AutoGenerate.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.AutoGenerate.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-switch
                                v-model="viewData.OrderReceipt.SelfUseAutoGenerate"
                                :disabled="!userCanManage"
                                :label="viewData.OrderReceipt.SelfUseAutoGenerate ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                                class="ma-0 text-no-wrap"
                                color="success"
                                hide-details
                                inset
                              />
                            </v-col>
                            <v-col
                              class="pa-0 ma-0"
                              cols="12"
                            />

                            <template v-if="viewData.OrderReceipt.SelfUseAutoGenerate">
                              <v-col cols="12">
                                <v-simple-table>
                                  <template #default>
                                    <thead>
                                      <tr>
                                        <th
                                          class="text-left"
                                          style="width: 200px;"
                                        >
                                          {{ $t('Restaurant.CatalogAddDialog.Field.OrderStatus.Label') }}
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <tr>
                                        <td class="pa-2">
                                          <v-select
                                            v-model="viewData.OrderReceipt.SelfUseStatusAutoGenerate"
                                            :items="orderStatusesFiltered"
                                            :label="$t('Restaurant.CatalogAddDialog.Field.OrderStatus.Label')"
                                            class="d-inline-flex"
                                            dense
                                            hide-details
                                            item-text="Name"
                                            item-value="Id"
                                            outlined
                                            single-line
                                            style="max-width: 180px;"
                                          >
                                            <template #selection="{item}">
                                              <v-chip
                                                :color="item.Status ? 'green' : ''"
                                                :dark="item.Status"
                                                class="pl-0"
                                                label
                                                small
                                                style="width: 100%;"
                                              >
                                                <v-avatar
                                                  :color="item.Avatar.Color"
                                                  class="mr-2"
                                                  tile
                                                >
                                                  <v-icon class="white--text">
                                                    {{ item.Avatar.Icon }}
                                                  </v-icon>
                                                </v-avatar>
                                                <span>{{ item.Name }}</span>
                                              </v-chip>
                                            </template>

                                            <template #item="data">
                                              <v-list-item-avatar :color="data.item.Avatar.Color">
                                                <v-icon dark>
                                                  {{ data.item.Avatar.Icon }}
                                                </v-icon>
                                              </v-list-item-avatar>

                                              <v-list-item-content>
                                                <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                              </v-list-item-content>
                                            </template>
                                          </v-select>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-col>

                              <v-col cols="12">
                                <v-simple-table>
                                  <template #default>
                                    <thead>
                                      <tr>
                                        <th
                                          class="text-left"
                                          style="width: 200px;"
                                        >
                                          {{ $t('Order.SourceType.Title') }}
                                        </th>

                                        <th
                                          class="text-left"
                                          style="width: 280px;"
                                        >
                                          {{ $t('Order.Type.Title') }}
                                        </th>

                                        <th class="text-left">
                                          {{ $t('Common.Button.Toggle.ActiveF') }}
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <template v-for="(sourceType, sourceTypeIdx) in viewData.OrderReceipt.SelfUseSourcesAutoGenerate">
                                        <tr
                                          v-if="(sourceType.id === 0 && sourceType.active) || (!viewData.OrderReceipt.SelfUseSourcesAutoGenerate[0]?.active)"
                                          :key="`source-type-${sourceTypeIdx}`"
                                        >
                                          <td class="pa-2">
                                            <v-chip
                                              :color="getSourceTypeById(sourceType.id).Status ? 'green' : ''"
                                              :dark="getSourceTypeById(sourceType.id).Status"
                                              class="pl-0"
                                              label
                                              style="width: 180px; height: 40px;"
                                            >
                                              <v-avatar
                                                :color="getSourceTypeById(sourceType.id).Avatar.Color"
                                                class="mr-2"
                                                style="width: 40px !important; height: 40px !important;"
                                                tile
                                              >
                                                <v-icon
                                                  v-if="getSourceTypeById(sourceType.id).Avatar.Icon"
                                                  class="white--text"
                                                >
                                                  {{ getSourceTypeById(sourceType.id).Avatar.Icon }}
                                                </v-icon>

                                                <img
                                                  v-else
                                                  :src="getSourceTypeById(sourceType.id).Avatar.Img"
                                                >
                                              </v-avatar>
                                              <span>{{ getSourceTypeById(sourceType.id).Name }}</span>
                                            </v-chip>
                                          </td>

                                          <td class="pa-2">
                                            <v-select
                                              v-model="sourceType.orderType"
                                              :disabled="sourceType.id === 0"
                                              :items="orderTypesListFiltered"
                                              :label="$t('Restaurant.CatalogAddDialog.Field.OrderType.Label')"
                                              class="pt-0"
                                              dense
                                              hide-details
                                              item-text="Name"
                                              item-value="Id"
                                              outlined
                                              single-line
                                              style="max-width: 260px;"
                                            >
                                              <template #selection="{item}">
                                                <v-chip
                                                  :color="item.Status ? 'green' : ''"
                                                  :dark="item.Status"
                                                  class="pl-0"
                                                  label
                                                  small
                                                  style="width: 100%;"
                                                >
                                                  <v-avatar
                                                    :color="item.Color"
                                                    class="mr-2"
                                                    tile
                                                  >
                                                    <v-icon class="white--text">
                                                      {{ item.Icon }}
                                                    </v-icon>
                                                  </v-avatar>
                                                  <span>{{ item.Name }}</span>
                                                </v-chip>
                                              </template>

                                              <template #item="data">
                                                <v-list-item-avatar :color="data.item.Color">
                                                  <v-icon dark>
                                                    {{ data.item.Icon }}
                                                  </v-icon>
                                                </v-list-item-avatar>

                                                <v-list-item-content>
                                                  <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                                </v-list-item-content>
                                              </template>
                                            </v-select>
                                          </td>

                                          <td class="pa-2">
                                            <v-switch
                                              v-model="sourceType.active"
                                              :disabled="!userCanManage"
                                              class="ma-0 pa-0 d-inline-flex"
                                              color="success"
                                              hide-details
                                              inset
                                              @change="onSourceOrderTypeChangeSelfUse(sourceType)"
                                            />
                                          </td>
                                        </tr>
                                      </template>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-col>
                            </template>
                          </v-row>

                          <v-row dense>
                            <v-col cols="12" />
                          </v-row>

                          <!-- Receipt Return 8.5 -->
                          <v-row
                            align="center"
                            dense
                          >
                            <v-col cols="12">
                              <v-card flat>
                                <v-card-title :class="[receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS)]">
                                  <div class="d-flex justify-start align-center">
                                    <v-icon
                                      :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS, false, true)"
                                      class="pr-3"
                                      dark
                                    >
                                      {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS) }}
                                    </v-icon>
                                    <h5 class="text-body-2 font-weight-bold white--text">
                                      <lang-search-highlight
                                        :lang-text="$t('Settings.Documents.OrderReceipt.Document.ReturnReceipt')"
                                        :search-text="langSearchText"
                                        highlight
                                      />
                                    </h5>
                                  </div>

                                  <v-spacer />
                                </v-card-title>

                                <v-divider />

                                <v-card-text class="px-2">
                                  <v-container
                                    class="pa-0"
                                    fluid
                                  >
                                    <v-row
                                      align="center"
                                      dense
                                    >
                                      <v-col>
                                        <h5 class="text-body-2 font-weight-bold">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.SeriesCredit.Title')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </h5>
                                        <div class="text-caption">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.SeriesCredit.Subtitle')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </div>
                                      </v-col>
                                      <v-col class="shrink">
                                        <v-text-field
                                          v-model="viewData.OrderReceipt.SelfUseCreditSeries"
                                          :disabled="viewData.OrderReceipt.HasReceiptsSelfUseCredit"
                                          :hide-details="viewData.OrderReceipt.HasReceiptsSelfUseCredit"
                                          dense
                                          outlined
                                          required
                                          single-line
                                          style="min-width: 100px; max-width: 100px;"
                                        />
                                      </v-col>

                                      <v-col cols="12">
                                        <v-divider class="" />
                                      </v-col>

                                      <v-col>
                                        <h5 class="text-body-2 font-weight-bold">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Title')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </h5>
                                        <div class="text-caption">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Subtitle')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </div>
                                      </v-col>
                                      <v-col class="shrink">
                                        <v-text-field
                                          v-model="viewData.OrderReceipt.SelfUseTotalCreditCheckInit"
                                          :disabled="viewData.OrderReceipt.HasReceiptsSelfUseCredit"
                                          :hide-details="viewData.OrderReceipt.HasReceiptsSelfUseCredit"
                                          :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Error.InvalidNumber')]"
                                          dense
                                          outlined
                                          required
                                          single-line
                                          style="min-width: 100px; max-width: 100px;"
                                          type="number"
                                          @focusout="onTotalSelfUseReturnReceiptCheckInitFocusOut"
                                        />
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </template>

                  <!-- Receipt Collection 8.4 -->
                  <template v-if="userIsSuperAdmin">
                    <v-expansion-panel :readonly="!viewData.OrderReceipt.CollectionEnabled">
                      <v-expansion-panel-header
                        :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CASH_POS)"
                        :hide-actions="!viewData.OrderReceipt.CollectionEnabled"
                        class="white--text mb-1 rounded"
                      >
                        <div class="d-flex justify-start align-center">
                          <v-icon
                            :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CASH_POS, false, true)"
                            class="pr-3"
                            dark
                          >
                            {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_RECEIPT_CASH_POS) }}
                          </v-icon>
                          <h5 class="text-body-2 font-weight-bold">
                            <lang-search-highlight
                              :lang-text="$t('Settings.Documents.OrderReceipt.Document.CollectionReceipt')"
                              :search-text="langSearchText"
                              highlight
                            />
                          </h5>

                          <v-spacer />

                          <v-switch
                            v-model="viewData.OrderReceipt.CollectionEnabled"
                            :class="viewData.OrderReceipt.CollectionEnabled ? 'mr-8' : 'mr-10'"
                            :disabled="!userCanManage"
                            :label="viewData.OrderReceipt.CollectionEnabled ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                            class="ma-0 text-no-wrap"
                            color="white"
                            dark
                            hide-details
                            inset
                          />
                        </div>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <v-container
                          class="px-0 py-2"
                          fluid
                        >
                          <v-row
                            align="center"
                            dense
                          >
                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Series.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Series.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-text-field
                                v-model="viewData.OrderReceipt.CollectionSeries"
                                :disabled="viewData.OrderReceipt.HasCollectionReceipts"
                                :hide-details="viewData.OrderReceipt.HasCollectionReceipts"
                                dense
                                outlined
                                required
                                single-line
                                style="min-width: 100px; max-width: 100px;"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="" />
                            </v-col>

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInit.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInit.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-text-field
                                v-model="viewData.OrderReceipt.CollectionTotalCheckInit"
                                :disabled="viewData.OrderReceipt.HasCollectionReceipts"
                                :hide-details="viewData.OrderReceipt.HasCollectionReceipts"
                                :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.TotalCheckInit.Error.InvalidNumber')]"
                                dense
                                outlined
                                required
                                single-line
                                style="min-width: 100px; max-width: 100px;"
                                type="number"
                                @focusout="onTotalCollectionReceiptCheckInitFocusOut"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-divider class="" />
                            </v-col>

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Notify.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.Notify.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-btn-toggle
                                v-model="viewData.OrderReceipt.CollectionNotify"
                                color="success"
                                multiple
                              >
                                <v-btn
                                  text
                                  value="print"
                                >
                                  {{ $t('Settings.Documents.OrderReceipt.Notify.Print').toLocaleUpperCase($i18n.locale) }}
                                </v-btn>

                                <v-btn
                                  :disabled="!appFiscalDocsProviderNotify.includes(NotifyTypeEnum.EMAIL)"
                                  text
                                  value="email"
                                >
                                  {{ $t('Settings.Documents.OrderReceipt.Notify.Email').toLocaleUpperCase($i18n.locale) }}
                                </v-btn>
                              </v-btn-toggle>
                            </v-col>
                          </v-row>

                          <v-row dense>
                            <v-col cols="12" />
                          </v-row>

                          <!-- Receipt Return 8.5 -->
                          <v-row
                            align="center"
                            dense
                          >
                            <v-col cols="12">
                              <v-card flat>
                                <v-card-title :class="[receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS)]">
                                  <div class="d-flex justify-start align-center">
                                    <v-icon
                                      :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS, false, true)"
                                      class="pr-3"
                                      dark
                                    >
                                      {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS) }}
                                    </v-icon>
                                    <h5 class="text-body-2 font-weight-bold white--text">
                                      <lang-search-highlight
                                        :lang-text="$t('Settings.Documents.OrderReceipt.Document.ReturnReceipt')"
                                        :search-text="langSearchText"
                                        highlight
                                      />
                                    </h5>
                                  </div>

                                  <v-spacer />
                                </v-card-title>

                                <v-divider />

                                <v-card-text class="px-2">
                                  <v-container
                                    class="pa-0"
                                    fluid
                                  >
                                    <v-row
                                      align="center"
                                      dense
                                    >
                                      <v-col>
                                        <h5 class="text-body-2 font-weight-bold">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.SeriesCredit.Title')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </h5>
                                        <div class="text-caption">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.SeriesCredit.Subtitle')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </div>
                                      </v-col>
                                      <v-col class="shrink">
                                        <v-text-field
                                          v-model="viewData.OrderReceipt.ReturnSeries"
                                          :disabled="viewData.OrderReceipt.HasReturnReceipts"
                                          :hide-details="viewData.OrderReceipt.HasReturnReceipts"
                                          dense
                                          outlined
                                          required
                                          single-line
                                          style="min-width: 100px; max-width: 100px;"
                                        />
                                      </v-col>

                                      <v-col cols="12">
                                        <v-divider class="" />
                                      </v-col>

                                      <v-col>
                                        <h5 class="text-body-2 font-weight-bold">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Title')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </h5>
                                        <div class="text-caption">
                                          <lang-search-highlight
                                            :lang-text="$t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Subtitle')"
                                            :search-text="langSearchText"
                                            highlight
                                          />
                                        </div>
                                      </v-col>
                                      <v-col class="shrink">
                                        <v-text-field
                                          v-model="viewData.OrderReceipt.ReturnTotalCheckInit"
                                          :disabled="viewData.OrderReceipt.HasReturnReceipts"
                                          :hide-details="viewData.OrderReceipt.HasReturnReceipts"
                                          :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.TotalCheckInitCredit.Error.InvalidNumber')]"
                                          dense
                                          outlined
                                          required
                                          single-line
                                          style="min-width: 100px; max-width: 100px;"
                                          type="number"
                                          @focusout="onTotalReturnReceiptCheckInitFocusOut"
                                        />
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </template>

                  <!-- Invoice Sale 1.1 -->
                  <v-expansion-panel :readonly="!viewData.OrderReceipt.InvoiceEnabled">
                    <v-expansion-panel-header
                      :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE)"
                      :hide-actions="!viewData.OrderReceipt.InvoiceEnabled"
                      class="white--text mb-1 rounded"
                    >
                      <div class="d-flex justify-start align-center">
                        <v-icon
                          :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE, false, true)"
                          class="pr-3"
                          dark
                        >
                          {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE) }}
                        </v-icon>
                        <h5 class="text-body-2 font-weight-bold">
                          <lang-search-highlight
                            :lang-text="$t('Settings.Documents.OrderReceipt.Document.Invoice')"
                            :search-text="langSearchText"
                            highlight
                          />
                        </h5>

                        <v-spacer />

                        <v-switch
                          v-model="viewData.OrderReceipt.InvoiceEnabled"
                          :class="viewData.OrderReceipt.InvoiceEnabled ? 'mr-8' : 'mr-10'"
                          :disabled="!userCanManage"
                          :label="viewData.OrderReceipt.InvoiceEnabled ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                          class="ma-0 text-no-wrap"
                          color="white"
                          dark
                          hide-details
                          inset
                        />
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-container
                        class="px-0 py-2"
                        fluid
                      >
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceSeries.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceSeries.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.InvoiceSeries"
                              :disabled="viewData.OrderReceipt.HasInvoices"
                              :hide-details="viewData.OrderReceipt.HasInvoices"
                              dense
                              outlined
                              required
                              single-line
                              style="min-width: 100px; max-width: 100px;"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInit.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInit.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.InvoiceTotalCheckInit"
                              :disabled="viewData.OrderReceipt.HasInvoices"
                              :hide-details="viewData.OrderReceipt.HasInvoices"
                              :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInit.Error.InvalidNumber')]"
                              dense
                              outlined
                              required
                              single-line
                              style="min-width: 100px; max-width: 100px;"
                              type="number"
                              @focusout="onTotalInvoiceCheckInitFocusOut"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceNotify.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceNotify.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink ri">
                            <v-btn-toggle
                              v-model="viewData.OrderReceipt.InvoiceNotify"
                              color="success"
                              multiple
                            >
                              <v-btn
                                text
                                value="print"
                              >
                                {{ $t('Settings.Documents.OrderReceipt.InvoiceNotify.Print').toLocaleUpperCase($i18n.locale) }}
                              </v-btn>

                              <v-btn
                                :disabled="!appFiscalDocsProviderNotify.includes(NotifyTypeEnum.EMAIL)"
                                text
                                value="email"
                              >
                                {{ $t('Settings.Documents.OrderReceipt.InvoiceNotify.Email').toLocaleUpperCase($i18n.locale) }}
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>


                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.InvoicePrintPerMachine"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.InvoicePrintPerMachine ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceAutoGenerate.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceAutoGenerate.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.InvoiceAutoGenerate"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.InvoiceAutoGenerate ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>
                          <v-col
                            class="pa-0 ma-0"
                            cols="12"
                          />

                          <template v-if="viewData.OrderReceipt.InvoiceAutoGenerate">
                            <v-col cols="12">
                              <v-simple-table>
                                <template #default>
                                  <thead>
                                    <tr>
                                      <th
                                        class="text-left"
                                        style="width: 200px;"
                                      >
                                        {{ $t('Restaurant.CatalogAddDialog.Field.OrderStatus.Label') }}
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr>
                                      <td class="pa-2">
                                        <v-select
                                          v-model="viewData.OrderReceipt.InvoiceStatusAutoGenerate"
                                          :items="orderStatusesFiltered"
                                          :label="$t('Restaurant.CatalogAddDialog.Field.OrderStatus.Label')"
                                          class="d-inline-flex"
                                          dense
                                          hide-details
                                          item-text="Name"
                                          item-value="Id"
                                          outlined
                                          single-line
                                          style="max-width: 180px;"
                                        >
                                          <template #selection="{item}">
                                            <v-chip
                                              :color="item.Status ? 'green' : ''"
                                              :dark="item.Status"
                                              class="pl-0"
                                              label
                                              small
                                              style="width: 100%;"
                                            >
                                              <v-avatar
                                                :color="item.Avatar.Color"
                                                class="mr-2"
                                                tile
                                              >
                                                <v-icon class="white--text">
                                                  {{ item.Avatar.Icon }}
                                                </v-icon>
                                              </v-avatar>
                                              <span>{{ item.Name }}</span>
                                            </v-chip>
                                          </template>

                                          <template #item="data">
                                            <v-list-item-avatar :color="data.item.Avatar.Color">
                                              <v-icon dark>
                                                {{ data.item.Avatar.Icon }}
                                              </v-icon>
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                              <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                            </v-list-item-content>
                                          </template>
                                        </v-select>
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>

                            <v-col cols="12">
                              <v-simple-table>
                                <template #default>
                                  <thead>
                                    <tr>
                                      <th
                                        class="text-left"
                                        style="width: 200px;"
                                      >
                                        {{ $t('Order.SourceType.Title') }}
                                      </th>

                                      <th
                                        class="text-left"
                                        style="width: 280px;"
                                      >
                                        {{ $t('Order.Type.Title') }}
                                      </th>

                                      <th class="text-left">
                                        {{ $t('Common.Button.Toggle.ActiveF') }}
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <template v-for="(sourceType, sourceTypeIdx) in viewData.OrderReceipt.InvoiceSourcesAutoGenerate">
                                      <tr
                                        v-if="(sourceType.id === 0 && sourceType.active) || (!viewData.OrderReceipt.InvoiceSourcesAutoGenerate[0].active)"
                                        :key="`source-type-${sourceTypeIdx}`"
                                      >
                                        <td class="pa-2">
                                          <v-chip
                                            :color="getSourceTypeById(sourceType.id).Status ? 'green' : ''"
                                            :dark="getSourceTypeById(sourceType.id).Status"
                                            class="pl-0"
                                            label
                                            style="width: 180px; height: 40px;"
                                          >
                                            <v-avatar
                                              :color="getSourceTypeById(sourceType.id).Avatar.Color"
                                              class="mr-2"
                                              style="width: 40px !important; height: 40px !important;"
                                              tile
                                            >
                                              <v-icon
                                                v-if="getSourceTypeById(sourceType.id).Avatar.Icon"
                                                class="white--text"
                                              >
                                                {{ getSourceTypeById(sourceType.id).Avatar.Icon }}
                                              </v-icon>

                                              <img
                                                v-else
                                                :src="getSourceTypeById(sourceType.id).Avatar.Img"
                                              >
                                            </v-avatar>
                                            <span>{{ getSourceTypeById(sourceType.id).Name }}</span>
                                          </v-chip>
                                        </td>

                                        <td class="pa-2">
                                          <v-select
                                            v-model="sourceType.orderType"
                                            :disabled="sourceType.id === 0"
                                            :items="orderTypesListFiltered"
                                            :label="$t('Restaurant.CatalogAddDialog.Field.OrderType.Label')"
                                            class="pt-0"
                                            dense
                                            hide-details
                                            item-text="Name"
                                            item-value="Id"
                                            outlined
                                            single-line
                                            style="max-width: 260px;"
                                          >
                                            <template #selection="{item}">
                                              <v-chip
                                                :color="item.Status ? 'green' : ''"
                                                :dark="item.Status"
                                                class="pl-0"
                                                label
                                                small
                                                style="width: 100%;"
                                              >
                                                <v-avatar
                                                  :color="item.Color"
                                                  class="mr-2"
                                                  tile
                                                >
                                                  <v-icon class="white--text">
                                                    {{ item.Icon }}
                                                  </v-icon>
                                                </v-avatar>
                                                <span>{{ item.Name }}</span>
                                              </v-chip>
                                            </template>

                                            <template #item="data">
                                              <v-list-item-avatar :color="data.item.Color">
                                                <v-icon dark>
                                                  {{ data.item.Icon }}
                                                </v-icon>
                                              </v-list-item-avatar>

                                              <v-list-item-content>
                                                <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                              </v-list-item-content>
                                            </template>
                                          </v-select>
                                        </td>

                                        <td class="pa-2">
                                          <v-switch
                                            v-model="sourceType.active"
                                            :disabled="!userCanManage"
                                            class="ma-0 pa-0 d-inline-flex"
                                            color="success"
                                            hide-details
                                            inset
                                            @change="onInvoiceSourceOrderTypeChange(sourceType)"
                                          />
                                        </td>
                                      </tr>
                                    </template>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>
                          </template>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" />
                        </v-row>

                        <!-- Invoice Credit -->
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col cols="12">
                            <v-card flat>
                              <v-card-title :class="[receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1)]">
                                <div class="d-flex justify-start align-center">
                                  <v-icon
                                    :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1, false, true)"
                                    class="pr-3"
                                    dark
                                  >
                                    {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1) }}
                                  </v-icon>
                                  <h5 class="text-body-2 font-weight-bold white--text">
                                    <lang-search-highlight
                                      :lang-text="$t('Settings.Documents.OrderReceipt.Document.InvoiceCredit')"
                                      :search-text="langSearchText"
                                      highlight
                                    />
                                  </h5>
                                </div>

                                <v-spacer />
                              </v-card-title>

                              <v-divider />

                              <v-card-text class="px-2">
                                <v-container
                                  class="pa-0"
                                  fluid
                                >
                                  <v-row
                                    align="center"
                                    dense
                                  >
                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceSeriesCredit.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceSeriesCredit.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.InvoiceCreditSeries"
                                        :disabled="viewData.OrderReceipt.HasInvoicesCredit"
                                        :hide-details="viewData.OrderReceipt.HasInvoicesCredit"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                      />
                                    </v-col>

                                    <v-col cols="12">
                                      <v-divider class="" />
                                    </v-col>

                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInitCredit.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInitCredit.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.InvoiceCreditTotalCheckInit"
                                        :disabled="viewData.OrderReceipt.HasInvoicesCredit"
                                        :hide-details="viewData.OrderReceipt.HasInvoicesCredit"
                                        :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInitCredit.Error.InvalidNumber')]"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                        type="number"
                                        @focusout="onTotalInvoiceCreditCheckInitFocusOut"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- Invoice Service 2.1 -->
                  <v-expansion-panel :readonly="!viewData.OrderReceipt.ServiceInvoiceEnabled">
                    <v-expansion-panel-header
                      :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_SERVICE_INVOICE)"
                      :hide-actions="!viewData.OrderReceipt.ServiceInvoiceEnabled"
                      class="white--text mb-1 rounded"
                    >
                      <div class="d-flex justify-start align-center">
                        <v-icon
                          :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_SERVICE_INVOICE, false, true)"
                          class="pr-3"
                          dark
                        >
                          {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_SERVICE_INVOICE) }}
                        </v-icon>
                        <h5 class="text-body-2 font-weight-bold">
                          <lang-search-highlight
                            :lang-text="$t('Settings.Documents.OrderReceipt.Document.ServiceInvoice')"
                            :search-text="langSearchText"
                            highlight
                          />
                        </h5>

                        <v-spacer />

                        <v-switch
                          v-model="viewData.OrderReceipt.ServiceInvoiceEnabled"
                          :class="viewData.OrderReceipt.ServiceInvoiceEnabled ? 'mr-8' : 'mr-10'"
                          :disabled="!userCanManage"
                          :label="viewData.OrderReceipt.ServiceInvoiceEnabled ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                          class="ma-0 text-no-wrap"
                          color="white"
                          dark
                          hide-details
                          inset
                        />
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-container
                        class="px-0 py-2"
                        fluid
                      >
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceSeries.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceSeries.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.ServiceInvoiceSeries"
                              :disabled="viewData.OrderReceipt.HasServiceInvoices"
                              :hide-details="viewData.OrderReceipt.HasServiceInvoices"
                              dense
                              outlined
                              required
                              single-line
                              style="min-width: 100px; max-width: 100px;"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInit.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInit.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.ServiceInvoiceTotalCheckInit"
                              :disabled="viewData.OrderReceipt.HasServiceInvoices"
                              :hide-details="viewData.OrderReceipt.HasServiceInvoices"
                              :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInit.Error.InvalidNumber')]"
                              dense
                              outlined
                              required
                              single-line
                              style="min-width: 100px; max-width: 100px;"
                              type="number"
                              @focusout="onTotalServiceInvoiceCheckInitFocusOut"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceNotify.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceNotify.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-btn-toggle
                              v-model="viewData.OrderReceipt.ServiceInvoiceNotify"
                              color="success"
                              multiple
                            >
                              <v-btn
                                text
                                value="print"
                              >
                                {{ $t('Settings.Documents.OrderReceipt.InvoiceNotify.Print').toLocaleUpperCase($i18n.locale) }}
                              </v-btn>

                              <v-btn
                                :disabled="!appFiscalDocsProviderNotify.includes(NotifyTypeEnum.EMAIL)"
                                text
                                value="email"
                              >
                                {{ $t('Settings.Documents.OrderReceipt.InvoiceNotify.Email').toLocaleUpperCase($i18n.locale) }}
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" />
                        </v-row>

                        <!-- Invoice Credit -->
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col cols="12">
                            <v-card flat>
                              <v-card-title :class="[receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1)]">
                                <div class="d-flex justify-start align-center">
                                  <v-icon
                                    :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1, false, true)"
                                    class="pr-3"
                                    dark
                                  >
                                    {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1) }}
                                  </v-icon>
                                  <h5 class="text-body-2 font-weight-bold white--text">
                                    <lang-search-highlight
                                      :lang-text="$t('Settings.Documents.OrderReceipt.Document.ServiceInvoiceCredit')"
                                      :search-text="langSearchText"
                                      highlight
                                    />
                                  </h5>
                                </div>

                                <v-spacer />
                              </v-card-title>

                              <v-divider />

                              <v-card-text class="px-2">
                                <v-container
                                  class="pa-0"
                                  fluid
                                >
                                  <v-row
                                    align="center"
                                    dense
                                  >
                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceSeriesCredit.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceSeriesCredit.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.ServiceInvoiceCreditSeries"
                                        :disabled="viewData.OrderReceipt.HasServiceInvoicesCredit"
                                        :hide-details="viewData.OrderReceipt.HasServiceInvoicesCredit"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                      />
                                    </v-col>

                                    <v-col cols="12">
                                      <v-divider class="" />
                                    </v-col>

                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInitCredit.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInitCredit.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.ServiceInvoiceTotalCreditCheckInit"
                                        :disabled="viewData.OrderReceipt.HasServiceInvoicesCredit"
                                        :hide-details="viewData.OrderReceipt.HasServiceInvoicesCredit"
                                        :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.InvoiceTotalCheckInitCredit.Error.InvalidNumber')]"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                        type="number"
                                        @focusout="onTotalServiceInvoiceCreditCheckInitFocusOut"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- FnB -->
                  <v-expansion-panel :readonly="!viewData.OrderReceipt.FnbEnabled">
                    <v-expansion-panel-header
                      :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER)"
                      :hide-actions="!viewData.OrderReceipt.FnbEnabled"
                      class="white--text mb-1 rounded"
                    >
                      <div class="d-flex justify-start align-center">
                        <v-icon
                          :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER, false, true)"
                          class="pr-3"
                          dark
                        >
                          {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER) }}
                        </v-icon>
                        <h5 class="text-body-2 font-weight-bold">
                          <lang-search-highlight
                            :lang-text="$t('Settings.Documents.OrderReceipt.Document.Fnb')"
                            :search-text="langSearchText"
                            highlight
                          />
                        </h5>

                        <v-spacer />

                        <v-switch
                          v-model="viewData.OrderReceipt.FnbEnabled"
                          :class="viewData.OrderReceipt.FnbEnabled ? 'mr-8' : 'mr-10'"
                          :disabled="!userCanManage"
                          :label="viewData.OrderReceipt.FnbEnabled ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                          class="ma-0 text-no-wrap"
                          color="white"
                          dark
                          hide-details
                          inset
                        />
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-container
                        class="px-0 py-2"
                        fluid
                      >
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FnbSeries.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FnbSeries.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.FnbSeries"
                              :disabled="viewData.OrderReceipt.HasFnb"
                              :hide-details="viewData.OrderReceipt.HasFnb"
                              dense
                              outlined
                              required
                              single-line
                              style="min-width: 100px; max-width: 100px;"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FnbTotalCheckInit.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FnbTotalCheckInit.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.FnbTotalCheckInit"
                              :disabled="viewData.OrderReceipt.HasFnb"
                              :hide-details="viewData.OrderReceipt.HasFnb"
                              :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.FnbTotalCheckInit.Error.InvalidNumber')]"
                              dense
                              outlined
                              required
                              single-line
                              style="min-width: 100px; max-width: 100px;"
                              type="number"
                              @focusout="onTotalFnbCheckInitFocusOut"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.PrintPerMachine.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.FnbPrintPerMachine"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.FnbPrintPerMachine ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FnbAutoGenerate.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FnbAutoGenerate.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.FnbAutoGenerate"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.FnbAutoGenerate ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FnbAutoPrint.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FnbAutoPrint.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.FnbAutoPrint"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.FnbAutoPrint ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0 text-no-wrap"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" />
                        </v-row>

                        <!-- FnB Cancel -->
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col cols="12">
                            <v-card flat>
                              <v-card-title :class="[receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_CANCEL)]">
                                <div class="d-flex justify-start align-center">
                                  <v-icon
                                    :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_CANCEL, false, true)"
                                    class="pr-3"
                                    dark
                                  >
                                    {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_CANCEL) }}
                                  </v-icon>
                                  <h5 class="text-body-2 font-weight-bold white--text">
                                    <lang-search-highlight
                                      :lang-text="$t('Settings.Documents.OrderReceipt.Document.FnbCancel')"
                                      :search-text="langSearchText"
                                      highlight
                                    />
                                  </h5>
                                </div>

                                <v-spacer />
                              </v-card-title>

                              <v-divider />

                              <v-card-text class="px-2">
                                <v-container
                                  class="pa-0"
                                  fluid
                                >
                                  <v-row
                                    align="center"
                                    dense
                                  >
                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.FnbSeriesCancel.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.FnbSeriesCancel.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.FnbCancelSeries"
                                        :disabled="viewData.OrderReceipt.HasFnbCancel"
                                        :hide-details="viewData.OrderReceipt.HasFnbCancel"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                      />
                                    </v-col>

                                    <v-col cols="12">
                                      <v-divider class="" />
                                    </v-col>

                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.FnbTotalCheckInitCancel.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.FnbTotalCheckInitCancel.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.FnbCancelTotalCheckInit"
                                        :disabled="viewData.OrderReceipt.HasFnbCancel"
                                        :hide-details="viewData.OrderReceipt.HasFnbCancel"
                                        :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.FnbTotalCheckInitCancel.Error.InvalidNumber')]"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                        type="number"
                                        @focusout="onTotalFnbCreditCheckInitFocusOut"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" />
                        </v-row>

                        <!-- FnB Return -->
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col cols="12">
                            <v-card flat>
                              <v-card-title :class="[receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_RETURN)]">
                                <div class="d-flex justify-start align-center">
                                  <v-icon
                                    :color="receiptTypeColor(FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_RETURN, false, true)"
                                    class="pr-3"
                                    dark
                                  >
                                    {{ receiptTypeIcon(FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_RETURN) }}
                                  </v-icon>
                                  <h5 class="text-body-2 font-weight-bold white--text">
                                    <lang-search-highlight
                                      :lang-text="$t('Settings.Documents.OrderReceipt.Document.FnbReturn')"
                                      :search-text="langSearchText"
                                      highlight
                                    />
                                  </h5>
                                </div>

                                <v-spacer />
                              </v-card-title>

                              <v-divider />

                              <v-card-text class="px-2">
                                <v-container
                                  class="pa-0"
                                  fluid
                                >
                                  <v-row
                                    align="center"
                                    dense
                                  >
                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.FnbSeriesReturn.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.FnbSeriesReturn.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.FnbReturnSeries"
                                        :disabled="viewData.OrderReceipt.HasFnbReturn"
                                        :hide-details="viewData.OrderReceipt.HasFnbReturn"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                      />
                                    </v-col>

                                    <v-col cols="12">
                                      <v-divider class="" />
                                    </v-col>

                                    <v-col>
                                      <h5 class="text-body-2 font-weight-bold">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.FnbTotalCheckInitReturn.Title')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </h5>
                                      <div class="text-caption">
                                        <lang-search-highlight
                                          :lang-text="$t('Settings.Documents.OrderReceipt.FnbTotalCheckInitReturn.Subtitle')"
                                          :search-text="langSearchText"
                                          highlight
                                        />
                                      </div>
                                    </v-col>
                                    <v-col class="shrink">
                                      <v-text-field
                                        v-model="viewData.OrderReceipt.FnbReturnTotalCheckInit"
                                        :disabled="viewData.OrderReceipt.HasFnbReturn"
                                        :hide-details="viewData.OrderReceipt.HasFnbReturn"
                                        :rules="[(v) => String(v).length > 0 && parseInt(v) >= 0 && String(v).match(/^\d+$/i) !== null || $t('Settings.Documents.OrderReceipt.FnbTotalCheckInitReturn.Error.InvalidNumber')]"
                                        dense
                                        outlined
                                        required
                                        single-line
                                        style="min-width: 100px; max-width: 100px;"
                                        type="number"
                                        @focusout="onTotalFnbReturnCheckInitFocusOut"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- Other Settings -->
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      class="white--text mb-1 rounded"
                      color="grey darken-2"
                    >
                      <div class="d-flex justify-start align-center">
                        <v-icon
                          class="pr-3"
                          color="grey lighten-1"
                          dark
                        >
                          settings
                        </v-icon>
                        <h5 class="text-body-2 font-weight-bold">
                          <lang-search-highlight
                            :lang-text="$t('Settings.Documents.OrderReceipt.Document.Misc')"
                            :search-text="langSearchText"
                            highlight
                          />
                        </h5>

                        <v-spacer />
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-container
                        class="px-0 py-2"
                        fluid
                      >
                        <v-row
                          align="center"
                          dense
                        >
                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowHeadquarters.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowHeadquarters.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowPrintHeadquarters"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowPrintHeadquarters ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowCategories.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowCategories.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowCategories"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowCategories ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>


                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowLogo.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowLogo.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowLogo"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowLogo ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col
                            class="pa-0 ma-0"
                            cols="12"
                          />

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.LogoWidth.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.LogoWidth.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.LogoWidth"
                              :disabled="!userCanManage"
                              class="elevation-0 d-inline-block ml-2"
                              dense
                              hide-details
                              min="0"
                              outlined
                              required
                              single-line
                              step="1"
                              style="min-width: 100px; max-width: 100px;"
                              suffix="mm"
                              type="number"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowMap.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowMap.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                            <div class="text-caption grey--text">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowMap.Hint')"
                                :search-text="langSearchText"
                                highlight
                              />
                              <router-link :to="{name: 'SystemSettingsDelivery'}">
                                {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                              </router-link>
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowMap"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowMap ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <template v-if="viewData.OrderReceipt.ShowMap">
                            <v-col
                              class="pa-0 ma-0"
                              cols="12"
                            />

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.MapWidth.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.MapWidth.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-text-field
                                v-model="viewData.OrderReceipt.MapWidth"
                                :disabled="!userCanManage"
                                class="elevation-0 d-inline-block ml-2"
                                dense
                                hide-details
                                min="0"
                                outlined
                                required
                                single-line
                                step="1"
                                style="min-width: 100px; max-width: 100px;"
                                suffix="mm"
                                type="number"
                              />
                            </v-col>
                          </template>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowQRCode.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowQRCode.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                            <div class="text-caption grey--text">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowQRCode.Hint')"
                                :search-text="langSearchText"
                                highlight
                              />
                              <router-link :to="{name: 'SystemSettingsDelivery'}">
                                {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                              </router-link>
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowMapQr"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowMapQr ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <template v-if="viewData.OrderReceipt.ShowMapQr">
                            <v-col
                              class="pa-0 ma-0"
                              cols="12"
                            />

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.QrWidth.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                              <div class="text-caption">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.QrWidth.Subtitle')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </div>
                            </v-col>
                            <v-col class="shrink">
                              <v-text-field
                                v-model="viewData.OrderReceipt.QrWidth"
                                :disabled="!userCanManage"
                                class="elevation-0 d-inline-block ml-2"
                                dense
                                hide-details
                                min="0"
                                outlined
                                required
                                single-line
                                step="1"
                                style="min-width: 100px; max-width: 100px;"
                                suffix="mm"
                                type="number"
                              />
                            </v-col>
                          </template>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowCustomer.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowCustomer.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowCustomer"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowCustomer ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowOrderType.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowOrderType.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowOrderType"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowOrderType ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowPayment.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.ShowPayment.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowPayment"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowPayment ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderDocument.ShowPrintOrderDailyNumber.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderDocument.ShowPrintOrderDailyNumber.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.ShowPrintDailyCheck"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.ShowPrintDailyCheck ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.RespectWorkingHours.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.RespectWorkingHours.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.RespectWorkingHours"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.RespectWorkingHours ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderDocument.RespectAutoGenerateDocument.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderDocument.RespectAutoGenerateDocument.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.RespectAutoGenerateDocument"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.RespectAutoGenerateDocument ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.AllowWithNoDocument.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.AllowWithNoDocument.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.AllowWithNoDocument"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.AllowWithNoDocument ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <v-col
                            v-if="viewData.OrderReceipt.AllowWithNoDocument"
                            cols="12"
                          >
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.AllowWithNoDocumentSources.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>

                            <v-select
                              v-model="viewData.OrderReceipt.AllowWithNoDocumentSources"
                              :items="activeSourceTypes"
                              :label="$t('Settings.Printer.Header.Source')"
                              clearable
                              hide-details
                              item-text="Name"
                              item-value="Id"
                              multiple
                              prepend-inner-icon="mdi-cart-outline"
                              required
                              solo
                              style="min-width: 85px"
                            >
                              <template #selection="{item}">
                                <v-chip
                                  :color="item.Status ? 'green' : ''"
                                  :dark="item.Status"
                                  class="pl-0"
                                  label
                                  small
                                >
                                  <v-avatar
                                    :color="item.Avatar.Color"
                                    class="mr-2"
                                    tile
                                  >
                                    <v-icon
                                      v-if="item.Avatar.Icon"
                                      class="white--text"
                                    >
                                      {{ item.Avatar.Icon }}
                                    </v-icon>

                                    <img
                                      v-else
                                      :src="item.Avatar.Img"
                                    >
                                  </v-avatar>
                                  <span>{{ item.Description }}</span>
                                </v-chip>
                              </template>

                              <template #item="data">
                                <v-list-item-avatar
                                  :color="data.item.Avatar.Color"
                                  :size="28"
                                >
                                  <v-icon
                                    v-if="data.item.Avatar.Icon"
                                    class="white--text"
                                  >
                                    {{ data.item.Avatar.Icon }}
                                  </v-icon>

                                  <img
                                    v-else
                                    :src="data.item.Avatar.Img"
                                  >
                                </v-list-item-avatar>

                                <v-list-item-content>
                                  <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                                  <v-list-item-subtitle>{{ data.item.Description | truncate }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-select>
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.AllowWithNoDocumentOnTable.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.AllowWithNoDocumentOnTable.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-switch
                              v-model="viewData.OrderReceipt.AllowWithNoDocumentOnTable"
                              :disabled="!userCanManage"
                              :label="viewData.OrderReceipt.AllowWithNoDocumentOnTable ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                              class="ma-0"
                              color="success"
                              hide-details
                              inset
                            />
                          </v-col>

                          <template v-if="viewData.OrderReceipt.AllowWithNoDocumentOnTable">
                            <v-col cols="12" />

                            <v-col>
                              <h5 class="text-body-2 font-weight-bold">
                                <lang-search-highlight
                                  :lang-text="$t('Settings.Documents.OrderReceipt.AllowWithNoDocumentOnTableSources.Title')"
                                  :search-text="langSearchText"
                                  highlight
                                />
                              </h5>
                            </v-col>
                            <v-col class="shrink">
                              <v-switch
                                :disabled="!userCanManage"
                                :label="!!viewData.OrderReceipt.AllowWithNoDocumentOnTableSources.length ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                                :value="!!viewData.OrderReceipt.AllowWithNoDocumentOnTableSources.length"
                                class="ma-0"
                                color="success"
                                hide-details
                                inset
                                @click="() => {
                                  viewData.OrderReceipt.AllowWithNoDocumentOnTableSources = !!viewData.OrderReceipt.AllowWithNoDocumentOnTableSources.length ? [] : [SourceTypeEnum.TABLE]
                                }"
                              />
                            </v-col>
                          </template>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.MaxWidth.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.MaxWidth.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                            <div class="text-caption grey--text">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.MaxWidth.Hint')"
                                :search-text="langSearchText"
                                highlight
                              />
                              <router-link :to="{name: 'SystemSettingsPrinters'}">
                                {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                              </router-link>
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.MaxWidth"
                              :disabled="!userCanManage"
                              :label="$t('Settings.Printer.Header.MaxWidth')"
                              class="elevation-0 d-inline-block ml-2"
                              dense
                              hide-details
                              min="0"
                              outlined
                              required
                              single-line
                              step="1"
                              style="min-width: 100px; max-width: 100px;"
                              suffix="mm"
                              type="number"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-divider class="" />
                          </v-col>

                          <v-col>
                            <h5 class="text-body-2 font-weight-bold">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FontSize.Title')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </h5>
                            <div class="text-caption">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FontSize.Subtitle')"
                                :search-text="langSearchText"
                                highlight
                              />
                            </div>
                            <div class="text-caption grey--text">
                              <lang-search-highlight
                                :lang-text="$t('Settings.Documents.OrderReceipt.FontSize.Hint')"
                                :search-text="langSearchText"
                                highlight
                              />
                              <router-link :to="{name: 'SystemSettingsPrinters'}">
                                {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                              </router-link>
                            </div>
                          </v-col>
                          <v-col class="shrink">
                            <v-text-field
                              v-model="viewData.OrderReceipt.FontSize"
                              :disabled="!userCanManage"
                              :label="$t('Settings.Printer.Header.FontSize')"
                              class="elevation-0 d-inline-block ml-2"
                              dense
                              hide-details
                              min="0"
                              outlined
                              required
                              single-line
                              step="1"
                              style="min-width: 100px; max-width: 100px;"
                              suffix="pt"
                              type="number"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Totals Document -->
          <v-expansion-panel v-if="posUserHasComponentPermission('RECEIPTS', 'MANAGE')">
            <v-expansion-panel-header>
              <div class="d-flex justify-start align-center">
                <v-icon class="pr-3">
                  {{ $t('Settings.Documents.TotalsDocument.Icon') }}
                </v-icon>
                <h5 class="d-inline-block text-body-2 font-weight-bold">
                  <lang-search-highlight
                    :lang-text="$t('Settings.Documents.TotalsDocument.Title')"
                    :search-text="langSearchText"
                    highlight
                  />
                </h5>
              </div>
            </v-expansion-panel-header>

            <v-divider />

            <v-expansion-panel-content>
              <v-container
                class="pa-0 py-2"
                fluid
              >
                <v-row
                  align="center"
                  class="mt-1"
                >
                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.TotalsDocument.RespectWorkingHours.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.TotalsDocument.RespectWorkingHours.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderReceipt.RespectWorkingHoursReportZ"
                      :disabled="!userCanManage"
                      :label="viewData.OrderReceipt.RespectWorkingHoursReportZ ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.TotalsDocument.ShowPaymentsWithNoReceipts.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.TotalsDocument.ShowPaymentsWithNoReceipts.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.OrderReceipt.ShowPaymentsWithNoReceipts"
                      :disabled="!userCanManage"
                      :label="viewData.OrderReceipt.ShowPaymentsWithNoReceipts ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      class="ma-0"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.TotalsDocument.MaxWidth.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.TotalsDocument.MaxWidth.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                    <div class="text-caption grey--text">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.TotalsDocument.MaxWidth.Hint')"
                        :search-text="langSearchText"
                        highlight
                      />
                      <router-link :to="{name: 'SystemSettingsPrinters'}">
                        {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                      </router-link>
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-text-field
                      v-model="viewData.TotalsDocument.MaxWidth"
                      :disabled="!userCanManage"
                      :label="$t('Settings.Printer.Header.MaxWidth')"
                      class="elevation-0 d-inline-block ml-2"
                      dense
                      hide-details
                      min="0"
                      outlined
                      required
                      single-line
                      step="1"
                      style="min-width: 100px; max-width: 100px;"
                      suffix="mm"
                      type="number"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-divider class="" />
                  </v-col>

                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.TotalsDocument.FontSize.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.TotalsDocument.FontSize.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                    <div class="text-caption grey--text">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.TotalsDocument.FontSize.Hint')"
                        :search-text="langSearchText"
                        highlight
                      />
                      <router-link :to="{name: 'SystemSettingsPrinters'}">
                        {{ $t('Common.Button.Here').toLocaleLowerCase($i18n.locale) }}
                      </router-link>
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-text-field
                      v-model="viewData.TotalsDocument.FontSize"
                      :disabled="!userCanManage"
                      :label="$t('Settings.Printer.Header.FontSize')"
                      class="elevation-0 d-inline-block ml-2"
                      dense
                      hide-details
                      min="0"
                      outlined
                      required
                      single-line
                      step="1"
                      style="min-width: 100px; max-width: 100px;"
                      suffix="pt"
                      type="number"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Delivery Staff Document -->
          <v-expansion-panel v-if="posUserHasComponentPermission('DeliveryStaff', 'MANAGE')">
            <v-expansion-panel-header>
              <div class="d-flex justify-start align-center">
                <v-icon class="pr-3">
                  {{ $t('Settings.Documents.DeliveryStaffDocument.Icon') }}
                </v-icon>
                <h5 class="d-inline-block text-body-2 font-weight-bold">
                  <lang-search-highlight
                    :lang-text="$t('Settings.Documents.DeliveryStaffDocument.Title')"
                    :search-text="langSearchText"
                    highlight
                  />
                </h5>
              </div>
            </v-expansion-panel-header>

            <v-divider />

            <v-expansion-panel-content>
              <v-container
                class="pa-0 py-2"
                fluid
              >
                <v-row
                  align="center"
                >
                  <v-col>
                    <h5 class="text-body-2 font-weight-bold">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.DeliveryStaffDocument.PrintDeliveryStaffShiftWithOrders.Title')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </h5>
                    <div class="text-caption">
                      <lang-search-highlight
                        :lang-text="$t('Settings.Documents.DeliveryStaffDocument.PrintDeliveryStaffShiftWithOrders.Subtitle')"
                        :search-text="langSearchText"
                        highlight
                      />
                    </div>
                  </v-col>
                  <v-col class="shrink">
                    <v-switch
                      v-model="viewData.DeliveryStaffDocument.PrintDeliveryStaffShiftWithOrders"
                      :disabled="!userCanManage"
                      :label="viewData.DeliveryStaffDocument.PrintDeliveryStaffShiftWithOrders ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                      color="success"
                      hide-details
                      inset
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </v-card-text>

    <v-divider />

    <v-card-actions class="pa-4 settings-window-actions">
      <v-spacer />
      <v-btn
        class="light-blue--text text--darken-1"
        outlined
        to="/system-settings"
      >
        {{ $t('Common.Button.Close').toLocaleUpperCase($i18n.locale) }}
      </v-btn>
      <v-btn
        v-if="userCanManage"
        :disabled="viewData===null || isSaving"
        :loading="isSaving"
        class="green white--text elevation-0"
        @click="onSaveClick"
      >
        {{ $t('Common.Button.Save').toLocaleUpperCase($i18n.locale) }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'
import Translatable from '@/mixins/translatable'
import NotifyTypeEnum from '@/api/Enums/NotifyTypeEnum'
import SourceType from '@/mixins/orders/sourceType'
import {clone} from '@/lib/helper/helper'
import FiscalDocTypeCodeEnum from '@/api/Enums/FiscalDocTypeCodeEnum'
import ReceiptsCommon from '@/mixins/receipts/receiptsCommon'
import LangSearchHighlightMixin from '@/lang/highlight/langSearchHighlightMixin.js'
import LangSearchHighlight from '@/lang/highlight/LangSearchHighlight.vue'
import OrderStatusEnum from '@/api/Enums/OrderStatusEnum.js'
import SourceTypeEnum from '@/api/Enums/SourceTypeEnum.js'

export default {
  name      : 'SystemSettingsDocuments',
  components: {LangSearchHighlight},
  mixins    : [AppData, Auth, Translatable, SourceType, ReceiptsCommon, LangSearchHighlightMixin],
  data() {
    return {
      menuOrdersDailyOpenVisible : false,
      menuOrdersDailyCloseVisible: false,
      isSaving                   : false,
      viewData                   : null,
      expansionPanel             : null,
      docsExpansionPanel         : null
    }
  },
  computed: {
    SourceTypeEnum() {
      return SourceTypeEnum
    },
    FiscalDocTypeCodeEnum() {
      return FiscalDocTypeCodeEnum
    },
    NotifyTypeEnum() {
      return NotifyTypeEnum
    },

    orderStatusesFiltered() {
      return clone(this.$t('Order.OrdersAll.Filter.filterOrderStatus.Items')).filter(o => [OrderStatusEnum.Received, OrderStatusEnum.Accepted, OrderStatusEnum.Completed].includes(o.Id))
    },

    receiptsActive() {
      return this.appConfig?.LOCATION_DATA?.ReceiptsDomainEnabled && this.posUserHasComponentPermission('RECEIPTS', 'MANAGE')
    },

    activePaymentMethods() {
      return this.orderBy(this.viewData?.Payments || [], 'Site')
    },

    sourceTypesListFiltered() {
      let sourceTypesAll = this.appConfig?.SOURCE_TYPES?.DEFAULT?.ALL || {}
      let sourceTypesDefault = Object.values(this.appConfig?.SOURCE_TYPES?.DEFAULT || {})
      let sourceTypesOther = this.appConfig?.SOURCE_TYPES?.OTHER || []

      sourceTypesAll = [{
        Id         : sourceTypesAll.source_type_id,
        Name       : this.getOrderSourceTypeLangById(sourceTypesAll.source_type_id)?.Title || sourceTypesAll.title,
        Description: this.getOrderSourceTypeLangById(sourceTypesAll.source_type_id)?.Desc || sourceTypesAll.desc,
        Avatar     : {
          Icon : this.getOrderSourceTypeLangById(sourceTypesAll.source_type_id)?.Icon || sourceTypesAll.icon,
          Color: 'green'
        }
      }]

      sourceTypesDefault = sourceTypesDefault.filter(sourceType => !sourceType.deleted_at && sourceType.active).map(o => {
        return {
          Id         : o.source_type_id,
          Name       : this.getOrderSourceTypeLangById(o.source_type_id)?.Title || o.title,
          Description: this.getOrderSourceTypeLangById(o.source_type_id)?.Desc || o.desc,
          Avatar     : {
            Icon : this.getOrderSourceTypeLangById(o.source_type_id)?.Icon || o.logo,
            Color: 'blue-grey'
          }
        }
      })

      sourceTypesOther = sourceTypesOther.filter(sourceType => !sourceType.deleted_at && sourceType.active).map(o => {
        return {
          Id         : o.source_type_id,
          Name       : o.title,
          Description: o.desc,
          Avatar     : {
            Img  : o.logo,
            Color: 'blue-grey'
          }
        }
      })

      return [...sourceTypesAll, ...sourceTypesDefault, ...sourceTypesOther]
    },

    orderTypesListFiltered() {
      return this.$t('Restaurant.CatalogAddDialog.Field.OrderType.Items')
    }
  },
  watch: {
    'viewData.PreparationDocument.Enabled': function (newVal) {
      if (!newVal) this.expansionPanel = null
    },

    'viewData.OrderReceipt.Enabled': function (newVal) {
      if (!newVal) this.docsExpansionPanel = null
    },

    'viewData.OrderReceipt.ServiceEnabled': function (newVal) {
      if (!newVal) this.docsExpansionPanel = null
    },

    'viewData.OrderReceipt.InvoiceEnabled': function (newVal) {
      if (!newVal) this.docsExpansionPanel = null
    },

    'viewData.OrderReceipt.ServiceInvoiceEnabled': function (newVal) {
      if (!newVal) this.docsExpansionPanel = null
    }
  },
  created() {
  },
  mounted() {
    this.$bus.$on(window.SocketCommand.Settings.Documents.Get, this.onGetDataResponse)
    this.$bus.$on(window.SocketCommand.Settings.Documents.Save, this.onSaveDataResponse)
    this.getData()
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off(window.SocketCommand.Settings.Documents.Get, this.onGetDataResponse)
    this.$bus.$off(window.SocketCommand.Settings.Documents.Save, this.onSaveDataResponse)
  },
  methods: {
    onTotalReceiptCheckInitFocusOut() {
      this.viewData.OrderReceipt.TotalCheckInit = parseInt(this.viewData.OrderReceipt.TotalCheckInit).toString()
    },
    onTotalCreditReceiptCheckInitFocusOut() {
      this.viewData.OrderReceipt.TotalCreditCheckInit = parseInt(this.viewData.OrderReceipt.TotalCreditCheckInit).toString()
    },

    onTotalServiceReceiptCheckInitFocusOut() {
      this.viewData.OrderReceipt.ServiceTotalCheckInit = parseInt(this.viewData.OrderReceipt.ServiceTotalCheckInit).toString()
    },
    onTotalServiceCreditReceiptCheckInitFocusOut() {
      this.viewData.OrderReceipt.ServiceTotalCreditCheckInit = parseInt(this.viewData.OrderReceipt.ServiceTotalCreditCheckInit).toString()
    },

    onTotalCollectionReceiptCheckInitFocusOut() {
      this.viewData.OrderReceipt.CollectionTotalCheckInit = parseInt(this.viewData.OrderReceipt.CollectionTotalCheckInit).toString()
    },
    onTotalReturnReceiptCheckInitFocusOut() {
      this.viewData.OrderReceipt.ReturnTotalCheckInit = parseInt(this.viewData.OrderReceipt.ReturnTotalCheckInit).toString()
    },

    onTotalInvoiceCheckInitFocusOut() {
      this.viewData.OrderReceipt.InvoiceTotalCheckInit = parseInt(this.viewData.OrderReceipt.InvoiceTotalCheckInit).toString()
    },
    onTotalInvoiceCreditCheckInitFocusOut() {
      this.viewData.OrderReceipt.InvoiceCreditTotalCheckInit = parseInt(this.viewData.OrderReceipt.InvoiceCreditTotalCheckInit).toString()
    },

    onTotalServiceInvoiceCheckInitFocusOut() {
      this.viewData.OrderReceipt.ServiceInvoiceTotalCheckInit = parseInt(this.viewData.OrderReceipt.ServiceInvoiceTotalCheckInit).toString()
    },
    onTotalServiceInvoiceCreditCheckInitFocusOut() {
      this.viewData.OrderReceipt.ServiceInvoiceTotalCreditCheckInit = parseInt(this.viewData.OrderReceipt.ServiceInvoiceTotalCreditCheckInit).toString()
    },

    onTotalFnbCheckInitFocusOut() {
      this.viewData.OrderReceipt.FnbTotalCheckInit = parseInt(this.viewData.OrderReceipt.FnbTotalCheckInit).toString()
    },
    onTotalFnbCreditCheckInitFocusOut() {
      this.viewData.OrderReceipt.FnbCreditTotalCheckInit = parseInt(this.viewData.OrderReceipt.FnbCreditTotalCheckInit).toString()
    },
    onTotalFnbReturnCheckInitFocusOut() {
      this.viewData.OrderReceipt.FnbReturnTotalCheckInit = parseInt(this.viewData.OrderReceipt.FnbReturnTotalCheckInit).toString()
    },

    onTotalSelfSupplyReceiptCheckInitFocusOut() {
      this.viewData.OrderReceipt.SelfSupplyTotalCheckInit = parseInt(this.viewData.OrderReceipt.SelfSupplyTotalCheckInit).toString()
    },
    onTotalSelfSupplyReturnReceiptCheckInitFocusOut() {
      this.viewData.OrderReceipt.SelfSupplyTotalCreditCheckInit = parseInt(this.viewData.OrderReceipt.SelfSupplyTotalCreditCheckInit).toString()
    },

    onTotalSelfUseReceiptCheckInitFocusOut() {
      this.viewData.OrderReceipt.SelfUseTotalCheckInit = parseInt(this.viewData.OrderReceipt.SelfUseotalCheckInit).toString()
    },
    onTotalSelfUseReturnReceiptCheckInitFocusOut() {
      this.viewData.OrderReceipt.SelfUseTotalCreditCheckInit = parseInt(this.viewData.OrderReceipt.SelfUseTotalCreditCheckInit).toString()
    },

    getData() {
      window.callAS(window.SocketCommand.Settings.Documents.Get, {})
    },

    onSourceOrderTypeChange(sourceType) {
      if (sourceType.id === 0 && !sourceType.active) {
        const sources = clone(this.viewData.OrderReceipt.SourcesAutoGenerate || [])
        for (let i = 0; i < sources.length; i++) {
          if (sources[i].id > 0) sources[i].active = false
        }

        this.viewData.OrderReceipt.SourcesAutoGenerate = sources
      }
    },

    onSourceOrderTypeChangeService(sourceType) {
      if (sourceType.id === 0 && !sourceType.active) {
        const sources = clone(this.viewData.OrderReceipt.ServiceSourcesAutoGenerate || [])
        for (let i = 0; i < sources.length; i++) {
          if (sources[i].id > 0) sources[i].active = false
        }

        this.viewData.OrderReceipt.ServiceSourcesAutoGenerate = sources
      }
    },

    onSourceOrderTypeChangeSelfSupply(sourceType) {
      if (sourceType.id === 0 && !sourceType.active) {
        const sources = clone(this.viewData.OrderReceipt.SelfSupplySourcesAutoGenerate || [])
        for (let i = 0; i < sources.length; i++) {
          if (sources[i].id > 0) sources[i].active = false
        }

        this.viewData.OrderReceipt.SelfSupplySourcesAutoGenerate = sources
      }
    },

    onSourceOrderTypeChangeSelfUse(sourceType) {
      if (sourceType.id === 0 && !sourceType.active) {
        const sources = clone(this.viewData.OrderReceipt.SelfUseSourcesAutoGenerate || [])
        for (let i = 0; i < sources.length; i++) {
          if (sources[i].id > 0) sources[i].active = false
        }

        this.viewData.OrderReceipt.SelfUseSourcesAutoGenerate = sources
      }
    },

    onInvoiceSourceOrderTypeChange(sourceType) {
      if (sourceType.id === 0 && !sourceType.active) {
        const sources = clone(this.viewData.OrderReceipt.InvoiceSourcesAutoGenerate || [])
        for (let i = 0; i < sources.length; i++) {
          if (sources[i].id > 0) sources[i].active = false
        }

        this.viewData.OrderReceipt.InvoiceourcesAutoGenerate = sources
      }
    },

    onGetDataResponse(result) {
      const types = ['SourcesAutoGenerate', 'InvoiceSourcesAutoGenerate', 'ServiceSourcesAutoGenerate', 'SelfSupplySourcesAutoGenerate', 'SelfUseSourcesAutoGenerate']

      types.forEach(type => {
        const sourcesAutoGenerate = result?.OrderReceipt[type] || []

        result.OrderReceipt[type] = this.sourceTypesListFiltered.map(defaultSourceType => {
          const sourceType = sourcesAutoGenerate.find(sourceType => sourceType.id === defaultSourceType.Id)
          return {
            id       : defaultSourceType.Id,
            orderType: defaultSourceType.Id === 0 ? 0 : sourceType?.orderType ?? 0,
            active   : sourceType?.active ?? false
          }
        })

      })

      this.viewData = result
    },

    getSourceTypeById(id) {
      return this.sourceTypesListFiltered.find(sourceType => parseInt(sourceType.Id) === parseInt(id))
    },

    onSaveClick() {
      this.isSaving = true
      this.onTotalReceiptCheckInitFocusOut()
      this.onTotalInvoiceCheckInitFocusOut()
      this.onTotalFnbCheckInitFocusOut()
      window.callAS(window.SocketCommand.Settings.Documents.Save, this.viewData)
    },

    onSaveDataResponse(result) {
      this.isSaving = false

      if (result.status) {
        // this.$router.replace({ name: 'SystemSettings' })
        this.getData()

        this.$bus.$emit('app-show-notification', {
          body: result.type,
          type: 'success',
          icon: 'check'
        })
      } else {
        this.$bus.$emit('app-show-notification', {
          body: this.$t('Settings.Documents.Notification'),
          type: 'error',
          icon: 'warning'
        })
      }
    }
  }
}
</script>

<style scoped>
:deep(.v-expansion-panel-content__wrap) {
  padding: 0 6px 16px;
}
</style>
